import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { DIRECTION } from "services/general";
import { detectCardType, CARD_TYPES } from "utils";
import {
  IconButton3Icon,
  IconButtonBlueIcon,
  TickCircleIcon,
} from "components/ui/icons/common";
import MaskIcon from "./MaskIcon";

export const PopupDelete = ({ props }) => {
  return (
    <img
      src="/icons/delete.svg"
      alt="icon"
      className="cursor-pointer"
      {...props}
    />
  );
};
export const PopupUpdate = () => {
  return (
    <img src="/icons/Edit-popup.svg" alt="icon" className="cursor-pointer" />
  );
};
export const Magnifier = ({ isWhite }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke="#666666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9984 20.9984L16.6484 16.6484"
        stroke="#666666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Messages = ({ isDark }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HomeIcon = ({ isDark }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M10 3H3V10H10V3Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.002 3H14.002V10H21.002V3Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.002 14.002H14.002V21.002H21.002V14.002Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.002H3V21.002H10V14.002Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ActiveHomeIcon = () => {
  return (
    <svg
      className="cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M11.4 0H15.525C16.3396 0 17 0.66038 17 1.475V5.6C17 6.41462 16.3396 7.075 15.525 7.075H11.4C10.5854 7.075 9.925 6.41462 9.925 5.6V1.475C9.925 0.66038 10.5854 0 11.4 0Z"
        fill="rgb(var(--color-primary))"
      />
      <path
        d="M1.8082 0H5.9332C6.74782 0 7.4082 0.66038 7.4082 1.475V5.6C7.4082 6.41462 6.74782 7.075 5.9332 7.075H1.8082C0.993583 7.075 0.333202 6.41462 0.333202 5.6V1.475C0.333202 0.66038 0.993583 0 1.8082 0Z"
        fill="rgb(var(--color-primary))"
      />
      <path
        d="M1.8165 9.58331H5.9415C6.75612 9.58331 7.4165 10.2437 7.4165 11.0583V15.1833C7.4165 15.9979 6.75612 16.6583 5.9415 16.6583H1.8165C1.00188 16.6583 0.341503 15.9979 0.341503 15.1833V11.0583C0.341503 10.2437 1.00188 9.58331 1.8165 9.58331Z"
        fill="rgb(var(--color-primary))"
      />
      <path
        d="M11.4 9.58331H15.525C16.3396 9.58331 17 10.2437 17 11.0583V15.1833C17 15.9979 16.3396 16.6583 15.525 16.6583H11.4C10.5854 16.6583 9.925 15.9979 9.925 15.1833V11.0583C9.925 10.2437 10.5854 9.58331 11.4 9.58331Z"
        fill="rgb(var(--color-primary))"
      />
    </svg>
  );
};
export const PermissionsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <g clipPath="url(#clip0_9221_1451)">
        <path
          d="M17.4873 5.83325H4.15397C3.2335 5.83325 2.4873 6.57944 2.4873 7.49992V15.8333C2.4873 16.7537 3.2335 17.4999 4.15397 17.4999H17.4873C18.4078 17.4999 19.154 16.7537 19.154 15.8333V7.49992C19.154 6.57944 18.4078 5.83325 17.4873 5.83325Z"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.154 17.5V4.16667C14.154 3.72464 13.9784 3.30072 13.6658 2.98816C13.3533 2.67559 12.9293 2.5 12.4873 2.5H9.15397C8.71194 2.5 8.28802 2.67559 7.97546 2.98816C7.6629 3.30072 7.4873 3.72464 7.4873 4.16667V17.5"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9221_1451">
          <rect
            width="20"
            height="20"
            fill="#455560"
            transform="translate(0.820312)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AdminsIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M9.00016 17.3334C4.39779 17.3334 0.666828 13.6024 0.666828 9.00002C0.666828 4.39765 4.39779 0.666687 9.00016 0.666687C13.6025 0.666687 17.3335 4.39765 17.3335 9.00002C17.3335 13.6024 13.6025 17.3334 9.00016 17.3334Z"
        fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
      />
      <path
        d="M9.00033 10.6167C7.25142 10.6167 5.83366 9.19889 5.83366 7.44999C5.83366 5.70109 7.25142 4.28333 9.00033 4.28333C10.7492 4.28333 12.167 5.70109 12.167 7.44999C12.167 9.19889 10.7492 10.6167 9.00033 10.6167Z"
        fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
      />
      <path
        d="M9.00033 17.3334C7.01227 17.3356 5.0897 16.6228 3.58366 15.325C3.97414 14.1994 4.70558 13.2234 5.67633 12.5327C6.64708 11.8419 7.80891 11.4708 9.00033 11.4708C10.1917 11.4708 11.3536 11.8419 12.3243 12.5327C13.2951 13.2234 14.0265 14.1994 14.417 15.325C12.9109 16.6228 10.9884 17.3356 9.00033 17.3334Z"
        fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
      />
    </svg>
  );
};
export const CustomersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <g clipPath="url(#clip0_9221_1438)">
        <path
          d="M14.9945 17.5V15.8333C14.9945 14.9493 14.6433 14.1014 14.0182 13.4763C13.393 12.8512 12.5452 12.5 11.6611 12.5H4.99447C4.11041 12.5 3.26256 12.8512 2.63744 13.4763C2.01232 14.1014 1.66113 14.9493 1.66113 15.8333V17.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.32845 9.16667C10.1694 9.16667 11.6618 7.67428 11.6618 5.83333C11.6618 3.99238 10.1694 2.5 8.32845 2.5C6.4875 2.5 4.99512 3.99238 4.99512 5.83333C4.99512 7.67428 6.4875 9.16667 8.32845 9.16667Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9951 17.5001V15.8334C19.9946 15.0948 19.7487 14.3774 19.2963 13.7937C18.8438 13.2099 18.2102 12.793 17.4951 12.6084"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1611 2.6084C14.8781 2.79198 15.5137 3.20898 15.9675 3.79366C16.4213 4.37833 16.6677 5.09742 16.6677 5.83757C16.6677 6.57771 16.4213 7.2968 15.9675 7.88147C15.5137 8.46615 14.8781 8.88315 14.1611 9.06673"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9221_1438">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.828125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const HumanResourcesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M16.8187 17.5V15.8333C16.8187 14.9493 16.4675 14.1014 15.8424 13.4763C15.2173 12.8512 14.3694 12.5 13.4854 12.5H6.81868C5.93463 12.5 5.08678 12.8512 4.46166 13.4763C3.83654 14.1014 3.48535 14.9493 3.48535 15.8333V17.5"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1527 9.16667C11.9936 9.16667 13.486 7.67428 13.486 5.83333C13.486 3.99238 11.9936 2.5 10.1527 2.5C8.31172 2.5 6.81934 3.99238 6.81934 5.83333C6.81934 7.67428 8.31172 9.16667 10.1527 9.16667Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EmployessIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6088_17627)">
        <path
          d="M10.0002 10C11.561 10 12.9752 10.5167 14.0127 11.2392C14.9985 11.9267 15.8335 12.9483 15.8335 14.0475C15.8335 14.6508 15.576 15.1508 15.1702 15.5225C14.7885 15.8733 14.2902 16.1008 13.7768 16.2558C12.751 16.5667 11.4002 16.6667 10.0002 16.6667C8.60016 16.6667 7.24933 16.5667 6.2235 16.2558C5.71016 16.1008 5.21183 15.8733 4.82933 15.5225C4.42516 15.1517 4.16683 14.6517 4.16683 14.0483C4.16683 12.9492 5.00183 11.9275 5.98766 11.24C7.02516 10.5167 8.43933 10 10.0002 10ZM15.8335 10.8333C16.7035 10.8333 17.4935 11.1208 18.0777 11.5275C18.611 11.9 19.1668 12.5192 19.1668 13.2742C19.1668 13.705 18.9793 14.0625 18.7002 14.3183C18.4452 14.5525 18.1302 14.69 17.8427 14.7767C17.451 14.895 16.9885 14.9558 16.5085 14.9825C16.6102 14.695 16.6668 14.3825 16.6668 14.0475C16.6668 12.7683 15.8677 11.6817 14.9735 10.9275C15.2559 10.865 15.5443 10.8334 15.8335 10.8333ZM4.16683 10.8333C4.46433 10.8333 4.75266 10.8667 5.02683 10.9275C4.1335 11.6817 3.3335 12.7683 3.3335 14.0475C3.3335 14.3825 3.39016 14.695 3.49183 14.9825C3.01183 14.9558 2.55016 14.895 2.15766 14.7767C1.87016 14.69 1.55516 14.5525 1.29933 14.3183C1.15256 14.1871 1.03519 14.0263 0.954913 13.8465C0.874634 13.6666 0.833258 13.4719 0.833497 13.275C0.833497 12.5208 1.3885 11.9008 1.92266 11.5283C2.58329 11.0752 3.36573 10.8329 4.16683 10.8333ZM15.4168 5.83333C15.9694 5.83333 16.4993 6.05283 16.89 6.44353C17.2807 6.83423 17.5002 7.36413 17.5002 7.91667C17.5002 8.4692 17.2807 8.99911 16.89 9.38981C16.4993 9.78051 15.9694 10 15.4168 10C14.8643 10 14.3344 9.78051 13.9437 9.38981C13.553 8.99911 13.3335 8.4692 13.3335 7.91667C13.3335 7.36413 13.553 6.83423 13.9437 6.44353C14.3344 6.05283 14.8643 5.83333 15.4168 5.83333ZM4.5835 5.83333C5.13603 5.83333 5.66594 6.05283 6.05664 6.44353C6.44734 6.83423 6.66683 7.36413 6.66683 7.91667C6.66683 8.4692 6.44734 8.99911 6.05664 9.38981C5.66594 9.78051 5.13603 10 4.5835 10C4.03096 10 3.50106 9.78051 3.11036 9.38981C2.71966 8.99911 2.50016 8.4692 2.50016 7.91667C2.50016 7.36413 2.71966 6.83423 3.11036 6.44353C3.50106 6.05283 4.03096 5.83333 4.5835 5.83333ZM10.0002 2.5C10.8842 2.5 11.7321 2.85119 12.3572 3.47631C12.9823 4.10143 13.3335 4.94928 13.3335 5.83333C13.3335 6.71739 12.9823 7.56524 12.3572 8.19036C11.7321 8.81548 10.8842 9.16667 10.0002 9.16667C9.11611 9.16667 8.26826 8.81548 7.64314 8.19036C7.01802 7.56524 6.66683 6.71739 6.66683 5.83333C6.66683 4.94928 7.01802 4.10143 7.64314 3.47631C8.26826 2.85119 9.11611 2.5 10.0002 2.5Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6088_17627">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ProsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M3.32422 7.50008L10.8242 1.66675L18.3242 7.50008V16.6667C18.3242 17.1088 18.1486 17.5327 17.8361 17.8453C17.5235 18.1578 17.0996 18.3334 16.6576 18.3334H4.99089C4.54886 18.3334 4.12493 18.1578 3.81237 17.8453C3.49981 17.5327 3.32422 17.1088 3.32422 16.6667V7.50008Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32422 18.3333V10H13.3242V18.3333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UnitsIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12273)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0233 2.24001C10.7307 2.01242 10.3706 1.88885 9.99992 1.88885C9.62925 1.88885 9.26916 2.01242 8.97659 2.24001L1.98992 7.67335C1.36326 8.16251 1.70826 9.16668 2.50242 9.16668H3.41242L4.09576 15.9992C4.13688 16.4104 4.32934 16.7917 4.63579 17.0691C4.94223 17.3464 5.34078 17.5 5.75409 17.5H14.2458C14.6591 17.5 15.0576 17.3464 15.3641 17.0691C15.6705 16.7917 15.863 16.4104 15.9041 15.9992L16.5874 9.16668H17.4974C18.2908 9.16668 18.6374 8.16251 18.0099 7.67418L11.0233 2.24001ZM9.99992 13.3333C10.663 13.3333 11.2989 13.07 11.7677 12.6011C12.2365 12.1323 12.4999 11.4964 12.4999 10.8333C12.4999 10.1703 12.2365 9.53442 11.7677 9.06558C11.2989 8.59674 10.663 8.33334 9.99992 8.33334C9.33688 8.33334 8.701 8.59674 8.23216 9.06558C7.76332 9.53442 7.49992 10.1703 7.49992 10.8333C7.49992 11.4964 7.76332 12.1323 8.23216 12.6011C8.701 13.07 9.33688 13.3333 9.99992 13.3333Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12273">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MessagesIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12282)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2498 2.5C13.1285 2.5 14.9301 3.24628 16.2585 4.57466C17.5869 5.90304 18.3332 7.70472 18.3332 9.58333C18.3332 11.462 17.5869 13.2636 16.2585 14.592C14.9301 15.9204 13.1285 16.6667 11.2498 16.6667H10.8332V17.4917C10.8332 17.6023 10.8114 17.7118 10.769 17.814C10.7267 17.9161 10.6646 18.0089 10.5864 18.0871C10.5081 18.1653 10.4152 18.2273 10.313 18.2695C10.2108 18.3118 10.1013 18.3334 9.99067 18.3333C7.94067 18.3317 5.864 17.6475 4.28817 16.2467C2.69817 14.8317 1.66817 12.7292 1.6665 10.0075V9.58333C1.6665 7.70472 2.41278 5.90304 3.74116 4.57466C5.06955 3.24628 6.87122 2.5 8.74984 2.5H11.2498ZM7.08317 8.33333C6.75165 8.33333 6.43371 8.46503 6.19929 8.69945C5.96487 8.93387 5.83317 9.25181 5.83317 9.58333C5.83317 9.91485 5.96487 10.2328 6.19929 10.4672C6.43371 10.7016 6.75165 10.8333 7.08317 10.8333C7.41469 10.8333 7.73263 10.7016 7.96705 10.4672C8.20147 10.2328 8.33317 9.91485 8.33317 9.58333C8.33317 9.25181 8.20147 8.93387 7.96705 8.69945C7.73263 8.46503 7.41469 8.33333 7.08317 8.33333ZM12.9165 8.33333C12.585 8.33333 12.267 8.46503 12.0326 8.69945C11.7982 8.93387 11.6665 9.25181 11.6665 9.58333C11.6665 9.91485 11.7982 10.2328 12.0326 10.4672C12.267 10.7016 12.585 10.8333 12.9165 10.8333C13.248 10.8333 13.566 10.7016 13.8004 10.4672C14.0348 10.2328 14.1665 9.91485 14.1665 9.58333C14.1665 9.25181 14.0348 8.93387 13.8004 8.69945C13.566 8.46503 13.248 8.33333 12.9165 8.33333Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12282">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const InventoriesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M5.16016 1.66675L2.66016 5.00008V16.6667C2.66016 17.1088 2.83575 17.5327 3.14831 17.8453C3.46087 18.1578 3.8848 18.3334 4.32682 18.3334H15.9935C16.4355 18.3334 16.8594 18.1578 17.172 17.8453C17.4846 17.5327 17.6602 17.1088 17.6602 16.6667V5.00008L15.1602 1.66675H5.16016Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66016 5H17.6602"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4938 8.33325C13.4938 9.21731 13.1426 10.0652 12.5175 10.6903C11.8924 11.3154 11.0445 11.6666 10.1605 11.6666C9.27643 11.6666 8.42858 11.3154 7.80346 10.6903C7.17834 10.0652 6.82715 9.21731 6.82715 8.33325"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ReportsIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12313)">
        <path
          d="M15.0002 1.66667C15.4422 1.66667 15.8661 1.84227 16.1787 2.15483C16.4912 2.46739 16.6668 2.89131 16.6668 3.33334V16.6667C16.6668 17.1087 16.4912 17.5326 16.1787 17.8452C15.8661 18.1577 15.4422 18.3333 15.0002 18.3333H5.00016C4.55814 18.3333 4.13421 18.1577 3.82165 17.8452C3.50909 17.5326 3.3335 17.1087 3.3335 16.6667V3.33334C3.3335 2.89131 3.50909 2.46739 3.82165 2.15483C4.13421 1.84227 4.55814 1.66667 5.00016 1.66667H15.0002ZM10.0002 10.8333H7.50016C7.27915 10.8333 7.06719 10.9211 6.91091 11.0774C6.75463 11.2337 6.66683 11.4457 6.66683 11.6667C6.66683 11.8877 6.75463 12.0996 6.91091 12.2559C7.06719 12.4122 7.27915 12.5 7.50016 12.5H10.0002C10.2212 12.5 10.4331 12.4122 10.5894 12.2559C10.7457 12.0996 10.8335 11.8877 10.8335 11.6667C10.8335 11.4457 10.7457 11.2337 10.5894 11.0774C10.4331 10.9211 10.2212 10.8333 10.0002 10.8333ZM12.5002 6.66667H7.50016C7.28776 6.66691 7.08347 6.74824 6.92902 6.89404C6.77458 7.03985 6.68163 7.23913 6.66919 7.45117C6.65674 7.6632 6.72572 7.87199 6.86205 8.03487C6.99837 8.19774 7.19175 8.30242 7.40266 8.32751L7.50016 8.33334H12.5002C12.7126 8.3331 12.9169 8.25177 13.0713 8.10596C13.2257 7.96016 13.3187 7.76088 13.3311 7.54884C13.3436 7.33681 13.2746 7.12802 13.1383 6.96514C13.002 6.80227 12.8086 6.69759 12.5977 6.6725L12.5002 6.66667Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12313">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AccountsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 6.66406C14.1421 6.66406 17.5 5.54477 17.5 4.16406C17.5 2.78335 14.1421 1.66406 10 1.66406C5.85786 1.66406 2.5 2.78335 2.5 4.16406C2.5 5.54477 5.85786 6.66406 10 6.66406Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10C17.5 11.3833 14.1667 12.5 10 12.5C5.83333 12.5 2.5 11.3833 2.5 10"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 4.16406V15.8307C2.5 17.2141 5.83333 18.3307 10 18.3307C14.1667 18.3307 17.5 17.2141 17.5 15.8307V4.16406"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SalesIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12336)">
        <path
          d="M15.0502 2.5C15.4516 2.50003 15.8395 2.64495 16.1427 2.90813C16.4458 3.1713 16.6438 3.53505 16.7002 3.9325L16.7143 4.0625L17.4435 15.7292C17.471 16.1669 17.3249 16.5979 17.0368 16.9286C16.7486 17.2593 16.3418 17.4631 15.9043 17.4958L15.7793 17.5H4.22184C3.78326 17.5 3.36234 17.3272 3.05035 17.0189C2.73835 16.7107 2.56044 16.2919 2.55518 15.8533L2.55768 15.7292L3.28684 4.0625C3.31192 3.66172 3.48085 3.28348 3.76257 2.99732C4.04428 2.71117 4.41984 2.53634 4.82018 2.505L4.95018 2.5H15.0502ZM12.5002 5.83333C12.2961 5.83336 12.0991 5.9083 11.9465 6.04393C11.794 6.17956 11.6966 6.36646 11.6727 6.56917L11.6668 6.66667C11.6668 7.10869 11.4912 7.53262 11.1787 7.84518C10.8661 8.15774 10.4422 8.33333 10.0002 8.33333C9.55815 8.33333 9.13423 8.15774 8.82166 7.84518C8.5091 7.53262 8.33351 7.10869 8.33351 6.66667C8.33351 6.44565 8.24571 6.23369 8.08943 6.07741C7.93315 5.92113 7.72119 5.83333 7.50018 5.83333C7.27916 5.83333 7.0672 5.92113 6.91092 6.07741C6.75464 6.23369 6.66684 6.44565 6.66684 6.66667C6.66684 7.55072 7.01803 8.39857 7.64315 9.02369C8.26827 9.64881 9.11612 10 10.0002 10C10.8842 10 11.7321 9.64881 12.3572 9.02369C12.9823 8.39857 13.3335 7.55072 13.3335 6.66667C13.3335 6.44565 13.2457 6.23369 13.0894 6.07741C12.9332 5.92113 12.7212 5.83333 12.5002 5.83333Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12336">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IncomesIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12331)">
        <path
          d="M6.24984 15.8333C6.58136 15.8333 6.8993 15.965 7.13372 16.1994C7.36814 16.4339 7.49984 16.7518 7.49984 17.0833C7.49984 17.4149 7.36814 17.7328 7.13372 17.9672C6.8993 18.2016 6.58136 18.3333 6.24984 18.3333C5.91832 18.3333 5.60037 18.2016 5.36595 17.9672C5.13153 17.7328 4.99984 17.4149 4.99984 17.0833C4.99984 16.7518 5.13153 16.4339 5.36595 16.1994C5.60037 15.965 5.91832 15.8333 6.24984 15.8333ZM14.5832 15.8333C14.9147 15.8333 15.2326 15.965 15.4671 16.1994C15.7015 16.4339 15.8332 16.7518 15.8332 17.0833C15.8332 17.4149 15.7015 17.7328 15.4671 17.9672C15.2326 18.2016 14.9147 18.3333 14.5832 18.3333C14.2517 18.3333 13.9337 18.2016 13.6993 17.9672C13.4649 17.7328 13.3332 17.4149 13.3332 17.0833C13.3332 16.7518 13.4649 16.4339 13.6993 16.1994C13.9337 15.965 14.2517 15.8333 14.5832 15.8333ZM2.49984 1.66666C3.93817 1.66666 5.019 2.73583 5.12067 4.16666H16.5015C16.7457 4.16663 16.9868 4.22024 17.208 4.3237C17.4292 4.42716 17.6249 4.57795 17.7813 4.7654C17.9378 4.95285 18.0511 5.17238 18.1134 5.40847C18.1756 5.64457 18.1852 5.89145 18.1415 6.13166L16.7773 13.6317C16.7075 14.0157 16.505 14.363 16.2053 14.6131C15.9056 14.8631 15.5277 15.0001 15.1373 15H5.77567C5.35412 15 4.94823 14.8403 4.63974 14.553C4.33126 14.2657 4.1431 13.8722 4.11317 13.4517L3.4465 4.1075C3.40817 3.59166 2.96984 3.33333 2.49984 3.33333C2.27882 3.33333 2.06686 3.24553 1.91058 3.08925C1.7543 2.93297 1.6665 2.72101 1.6665 2.5C1.6665 2.27898 1.7543 2.06702 1.91058 1.91074C2.06686 1.75446 2.27882 1.66666 2.49984 1.66666Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12331">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ContractsIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12386)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0002 1.66667V7.08333C10.0002 7.41485 10.1319 7.73279 10.3663 7.96722C10.6007 8.20164 10.9186 8.33333 11.2502 8.33333H16.6668V16.6667C16.6668 17.1087 16.4912 17.5326 16.1787 17.8452C15.8661 18.1577 15.4422 18.3333 15.0002 18.3333H5.00016C4.55814 18.3333 4.13421 18.1577 3.82165 17.8452C3.50909 17.5326 3.3335 17.1087 3.3335 16.6667V3.33333C3.3335 2.8913 3.50909 2.46738 3.82165 2.15482C4.13421 1.84226 4.55814 1.66667 5.00016 1.66667H10.0002ZM12.5002 12.5H7.50016C7.27915 12.5 7.06719 12.5878 6.91091 12.7441C6.75463 12.9004 6.66683 13.1123 6.66683 13.3333C6.66683 13.5543 6.75463 13.7663 6.91091 13.9226C7.06719 14.0789 7.27915 14.1667 7.50016 14.1667H12.5002C12.7212 14.1667 12.9331 14.0789 13.0894 13.9226C13.2457 13.7663 13.3335 13.5543 13.3335 13.3333C13.3335 13.1123 13.2457 12.9004 13.0894 12.7441C12.9331 12.5878 12.7212 12.5 12.5002 12.5ZM8.3335 9.16666H7.50016C7.27915 9.16666 7.06719 9.25446 6.91091 9.41074C6.75463 9.56702 6.66683 9.77898 6.66683 10C6.66683 10.221 6.75463 10.433 6.91091 10.5893C7.06719 10.7455 7.27915 10.8333 7.50016 10.8333H8.3335C8.55451 10.8333 8.76647 10.7455 8.92275 10.5893C9.07903 10.433 9.16683 10.221 9.16683 10C9.16683 9.77898 9.07903 9.56702 8.92275 9.41074C8.76647 9.25446 8.55451 9.16666 8.3335 9.16666ZM11.6668 1.7025C11.9826 1.76946 12.2721 1.92666 12.5002 2.155L16.1785 5.83333C16.4068 6.06144 16.564 6.35093 16.631 6.66667H11.6668V1.7025Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12386">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SupportCenterIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12381)">
        <path
          d="M9.99984 1.66667C14.6023 1.66667 18.3332 5.3975 18.3332 10C18.3332 14.6025 14.6023 18.3333 9.99984 18.3333C5.39734 18.3333 1.6665 14.6025 1.6665 10C1.6665 5.3975 5.39734 1.66667 9.99984 1.66667ZM9.99984 13.3333C9.77882 13.3333 9.56686 13.4211 9.41058 13.5774C9.2543 13.7337 9.1665 13.9457 9.1665 14.1667C9.1665 14.3877 9.2543 14.5996 9.41058 14.7559C9.56686 14.9122 9.77882 15 9.99984 15C10.2208 15 10.4328 14.9122 10.5891 14.7559C10.7454 14.5996 10.8332 14.3877 10.8332 14.1667C10.8332 13.9457 10.7454 13.7337 10.5891 13.5774C10.4328 13.4211 10.2208 13.3333 9.99984 13.3333ZM9.99984 5.41667C9.19866 5.41667 8.4303 5.73493 7.86378 6.30145C7.29727 6.86796 6.979 7.63632 6.979 8.4375C6.979 8.65851 7.0668 8.87047 7.22308 9.02675C7.37936 9.18303 7.59132 9.27083 7.81234 9.27083C8.03335 9.27083 8.24531 9.18303 8.40159 9.02675C8.55787 8.87047 8.64567 8.65851 8.64567 8.4375C8.64595 8.1917 8.71312 7.9506 8.83999 7.74007C8.96686 7.52954 9.14864 7.35751 9.36584 7.24243C9.58304 7.12735 9.82747 7.07356 10.0729 7.08682C10.3184 7.10009 10.5556 7.17991 10.7591 7.31773C10.9626 7.45554 11.1248 7.64616 11.2283 7.86914C11.3317 8.09212 11.3725 8.33905 11.3463 8.58345C11.3201 8.82785 11.2278 9.0605 11.0794 9.25647C10.9311 9.45243 10.7321 9.60432 10.504 9.69583C9.94067 9.92083 9.1665 10.4975 9.1665 11.4583V11.6667C9.1665 11.8877 9.2543 12.0996 9.41058 12.2559C9.56686 12.4122 9.77882 12.5 9.99984 12.5C10.2208 12.5 10.4328 12.4122 10.5891 12.2559C10.7454 12.0996 10.8332 11.8877 10.8332 11.6667C10.8332 11.4633 10.8748 11.3617 11.0507 11.275L11.1232 11.2417C11.7738 10.9799 12.3132 10.5 12.6488 9.8841C12.9844 9.26823 13.0952 8.55482 12.9624 7.86615C12.8296 7.17749 12.4614 6.55647 11.9209 6.10956C11.3803 5.66265 10.7012 5.41769 9.99984 5.41667Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12381">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SettingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12363)">
        <path
          d="M13.3333 12.5C14.4217 12.5 15.3483 13.1958 15.6917 14.1667H16.6667C16.8877 14.1667 17.0996 14.2545 17.2559 14.4107C17.4122 14.567 17.5 14.779 17.5 15C17.5 15.221 17.4122 15.433 17.2559 15.5893C17.0996 15.7455 16.8877 15.8333 16.6667 15.8333H15.6917C15.5195 16.3213 15.2002 16.7438 14.7778 17.0427C14.3554 17.3415 13.8508 17.502 13.3333 17.502C12.8159 17.502 12.3112 17.3415 11.8888 17.0427C11.4664 16.7438 11.1472 16.3213 10.975 15.8333H3.33333C3.11232 15.8333 2.90036 15.7455 2.74408 15.5893C2.5878 15.433 2.5 15.221 2.5 15C2.5 14.779 2.5878 14.567 2.74408 14.4107C2.90036 14.2545 3.11232 14.1667 3.33333 14.1667H10.975C11.1475 13.6791 11.4669 13.257 11.8893 12.9585C12.3116 12.66 12.8162 12.4999 13.3333 12.5ZM6.66667 7.5C7.15749 7.49993 7.63748 7.64435 8.04678 7.91524C8.45608 8.18613 8.77658 8.57151 8.96833 9.02333L9.02417 9.16667H16.6667C16.8791 9.1669 17.0834 9.24823 17.2378 9.39404C17.3923 9.53985 17.4852 9.73913 17.4976 9.95116C17.5101 10.1632 17.4411 10.372 17.3048 10.5349C17.1685 10.6977 16.9751 10.8024 16.7642 10.8275L16.6667 10.8333H9.025C8.857 11.3086 8.54931 11.722 8.14228 12.0193C7.73524 12.3166 7.24786 12.484 6.74404 12.4995C6.24022 12.515 5.74348 12.3779 5.31894 12.1061C4.8944 11.8344 4.56189 11.4407 4.365 10.9767L4.30833 10.8333H3.33333C3.12093 10.8331 2.91664 10.7518 2.76219 10.606C2.60775 10.4602 2.5148 10.2609 2.50236 10.0488C2.48991 9.8368 2.5589 9.62802 2.69522 9.46514C2.83155 9.30226 3.02492 9.19759 3.23583 9.1725L3.33333 9.16667H4.30833C4.48084 8.6791 4.80027 8.25702 5.22262 7.95853C5.64498 7.66005 6.14949 7.49985 6.66667 7.5ZM13.3333 2.5C14.4217 2.5 15.3483 3.19583 15.6917 4.16667H16.6667C16.8877 4.16667 17.0996 4.25446 17.2559 4.41074C17.4122 4.56702 17.5 4.77899 17.5 5C17.5 5.22101 17.4122 5.43298 17.2559 5.58926C17.0996 5.74554 16.8877 5.83333 16.6667 5.83333H15.6917C15.5195 6.32128 15.2002 6.74381 14.7778 7.04268C14.3554 7.34155 13.8508 7.50204 13.3333 7.50204C12.8159 7.50204 12.3112 7.34155 11.8888 7.04268C11.4664 6.74381 11.1472 6.32128 10.975 5.83333H3.33333C3.11232 5.83333 2.90036 5.74554 2.74408 5.58926C2.5878 5.43298 2.5 5.22101 2.5 5C2.5 4.77899 2.5878 4.56702 2.74408 4.41074C2.90036 4.25446 3.11232 4.16667 3.33333 4.16667H10.975C11.1475 3.6791 11.4669 3.25702 11.8893 2.95853C12.3116 2.66005 12.8162 2.49985 13.3333 2.5Z"
          fill={"#455560"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12363">
          <rect width="20" height="20" fill="#455560" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const RelationsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M15.4883 17.5C16.869 17.5 17.9883 16.3807 17.9883 15C17.9883 13.6193 16.869 12.5 15.4883 12.5C14.1076 12.5 12.9883 13.6193 12.9883 15C12.9883 16.3807 14.1076 17.5 15.4883 17.5Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.48828 7.5C6.86899 7.5 7.98828 6.38071 7.98828 5C7.98828 3.61929 6.86899 2.5 5.48828 2.5C4.10757 2.5 2.98828 3.61929 2.98828 5C2.98828 6.38071 4.10757 7.5 5.48828 7.5Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3213 5H13.8213C14.2633 5 14.6872 5.17559 14.9998 5.48816C15.3124 5.80072 15.488 6.22464 15.488 6.66667V12.5"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.48828 7.5V17.5"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ControlIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M12.4064 5.24994C12.2537 5.40572 12.1682 5.61515 12.1682 5.83328C12.1682 6.0514 12.2537 6.26083 12.4064 6.41661L13.7397 7.74994C13.8955 7.90263 14.1049 7.98816 14.323 7.98816C14.5412 7.98816 14.7506 7.90263 14.9064 7.74994L18.048 4.60828C18.4671 5.53427 18.5939 6.56597 18.4118 7.5659C18.2296 8.56582 17.747 9.48648 17.0283 10.2052C16.3096 10.9239 15.3889 11.4065 14.389 11.5887C13.3891 11.7708 12.3574 11.644 11.4314 11.2249L5.67304 16.9833C5.34152 17.3148 4.89188 17.501 4.42304 17.501C3.9542 17.501 3.50456 17.3148 3.17304 16.9833C2.84152 16.6518 2.65527 16.2021 2.65527 15.7333C2.65527 15.2644 2.84152 14.8148 3.17304 14.4833L8.93137 8.72494C8.51234 7.79895 8.38547 6.76725 8.56766 5.76732C8.74985 4.7674 9.23245 3.84674 9.95114 3.12804C10.6698 2.40935 11.5905 1.92675 12.5904 1.74456C13.5903 1.56237 14.622 1.68925 15.548 2.10828L12.4147 5.24161L12.4064 5.24994Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DbIcon = ({ isActive }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6094_12318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.16667 3.33333C3.72464 3.33333 3.30072 3.50892 2.98816 3.82148C2.67559 4.13404 2.5 4.55797 2.5 4.99999V8.33333C2.5 8.77536 2.67559 9.19928 2.98816 9.51184C3.30072 9.8244 3.72464 10 4.16667 10H15.8333C16.2754 10 16.6993 9.8244 17.0118 9.51184C17.3244 9.19928 17.5 8.77536 17.5 8.33333V4.99999C17.5 4.55797 17.3244 4.13404 17.0118 3.82148C16.6993 3.50892 16.2754 3.33333 15.8333 3.33333H4.16667ZM4.16667 10.8333C3.72464 10.8333 3.30072 11.0089 2.98816 11.3215C2.67559 11.634 2.5 12.058 2.5 12.5V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V12.5C17.5 12.058 17.3244 11.634 17.0118 11.3215C16.6993 11.0089 16.2754 10.8333 15.8333 10.8333H4.16667ZM5 14.1667C5 13.9456 5.0878 13.7337 5.24408 13.5774C5.40036 13.4211 5.61232 13.3333 5.83333 13.3333H7.5C7.72101 13.3333 7.93297 13.4211 8.08926 13.5774C8.24554 13.7337 8.33333 13.9456 8.33333 14.1667C8.33333 14.3877 8.24554 14.5996 8.08926 14.7559C7.93297 14.9122 7.72101 15 7.5 15H5.83333C5.61232 15 5.40036 14.9122 5.24408 14.7559C5.0878 14.5996 5 14.3877 5 14.1667ZM5.83333 5.83333C5.61232 5.83333 5.40036 5.92113 5.24408 6.07741C5.0878 6.23369 5 6.44565 5 6.66666C5 6.88768 5.0878 7.09964 5.24408 7.25592C5.40036 7.4122 5.61232 7.5 5.83333 7.5H7.5C7.72101 7.5 7.93297 7.4122 8.08926 7.25592C8.24554 7.09964 8.33333 6.88768 8.33333 6.66666C8.33333 6.44565 8.24554 6.23369 8.08926 6.07741C7.93297 5.92113 7.72101 5.83333 7.5 5.83333H5.83333Z"
          fill={isActive ? "rgb(var(--color-primary))" : "#A6BBC2"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6094_12318">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Notifications = ({ isDark }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M16.75 7.5C16.75 6.04131 16.1705 4.64236 15.1391 3.61091C14.1076 2.57946 12.7087 2 11.25 2C9.79131 2 8.39236 2.57946 7.36091 3.61091C6.32946 4.64236 5.75 6.04131 5.75 7.5C5.75 13.9167 3 15.75 3 15.75H19.5C19.5 15.75 16.75 13.9167 16.75 7.5Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8357 19.418C12.6746 19.6958 12.4433 19.9264 12.1649 20.0867C11.8866 20.247 11.5711 20.3314 11.2499 20.3314C10.9287 20.3314 10.6132 20.247 10.3349 20.0867C10.0565 19.9264 9.82522 19.6958 9.66406 19.418"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Logout = (props) => {
  const { isDark, ...rest } = props;
  return (
    <svg
      {...rest}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M15 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H15"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99805 17.001L2.99805 12.001L7.99805 7.00098"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12H15"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Language = ({ isDark }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M6 12H18"
        stroke="#AC7F5E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="12"
        cy="12"
        rx="3"
        ry="9"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12H21"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingsIcon = ({ isDark }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`cursor-pointer ${isDark ? "invert brightness-0" : ""}`}
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12.8804V11.1204C2 10.0804 2.85 9.22043 3.9 9.22043C5.71 9.22043 6.45 7.94042 5.54 6.37042C5.02 5.47042 5.33 4.30042 6.24 3.78042L7.97 2.79042C8.76 2.32042 9.78 2.60042 10.25 3.39042L10.36 3.58042C11.26 5.15042 12.74 5.15042 13.65 3.58042L13.76 3.39042C14.23 2.60042 15.25 2.32042 16.04 2.79042L17.77 3.78042C18.68 4.30042 18.99 5.47042 18.47 6.37042C17.56 7.94042 18.3 9.22043 20.11 9.22043C21.15 9.22043 22.01 10.0704 22.01 11.1204V12.8804C22.01 13.9204 21.16 14.7804 20.11 14.7804C18.3 14.7804 17.56 16.0604 18.47 17.6304C18.99 18.5404 18.68 19.7004 17.77 20.2204L16.04 21.2104C15.25 21.6804 14.23 21.4004 13.76 20.6104L13.65 20.4204C12.75 18.8504 11.27 18.8504 10.36 20.4204L10.25 20.6104C9.78 21.4004 8.76 21.6804 7.97 21.2104L6.24 20.2204C5.33 19.7004 5.02 18.5304 5.54 17.6304C6.45 16.0604 5.71 14.7804 3.9 14.7804C2.85 14.7804 2 13.9204 2 12.8804Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MenuFold = ({ isDark }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M12.3225 8.43917H1.60826C1.51004 8.43917 1.42969 8.35882 1.42969 8.2606V7.0106C1.42969 6.91239 1.51004 6.83203 1.60826 6.83203H12.3225C12.4208 6.83203 12.5011 6.91239 12.5011 7.0106V8.2606C12.5011 8.35882 12.4208 8.43917 12.3225 8.43917ZM12.5011 12.9927C12.5011 13.091 12.4208 13.1713 12.3225 13.1713H1.60826C1.51004 13.1713 1.42969 13.091 1.42969 12.9927V11.7427C1.42969 11.6445 1.51004 11.5642 1.60826 11.5642H12.3225C12.4208 11.5642 12.5011 11.6445 12.5011 11.7427V12.9927ZM1.25112 2.14453H18.7511C18.8493 2.14453 18.9297 2.22489 18.9297 2.3231V3.5731C18.9297 3.67132 18.8493 3.75167 18.7511 3.75167H1.25112C1.1529 3.75167 1.07254 3.67132 1.07254 3.5731V2.3231C1.07254 2.22489 1.1529 2.14453 1.25112 2.14453ZM1.25112 16.2517H18.7511C18.8493 16.2517 18.9297 16.332 18.9297 16.4302V17.6802C18.9297 17.7785 18.8493 17.8588 18.7511 17.8588H1.25112C1.1529 17.8588 1.07254 17.7785 1.07254 17.6802V16.4302C1.07254 16.332 1.1529 16.2517 1.25112 16.2517ZM18.8538 10.1557L15.365 12.9035C15.2355 13.0061 15.0435 12.9146 15.0435 12.7494V7.25391C15.0435 7.08873 15.2333 6.99721 15.365 7.09989L18.8538 9.84766C18.8773 9.8659 18.8962 9.88925 18.9093 9.91594C18.9224 9.94264 18.9291 9.97196 18.9291 10.0017C18.9291 10.0314 18.9224 10.0607 18.9093 10.0874C18.8962 10.1141 18.8773 10.1375 18.8538 10.1557Z"
        fill={isDark ? "white" : "#455560"}
      />
    </svg>
  );
};

export const Icon1 = ({ onClick, isActive }) => {
  const [hover, setHover] = useState(false);
  const color = hover || isActive ? "rgb(var(--color-brand))" : "#D9D9D9";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="cursor-pointer h-[44px] object-cover"
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <path
        d="M5.40039 2.1001H18.6004C19.7004 2.1001 20.6004 3.0001 20.6004 4.1001V6.3001C20.6004 7.1001 20.1004 8.1001 19.6004 8.6001L15.3004 12.4001C14.7004 12.9001 14.3004 13.9001 14.3004 14.7001V19.0001C14.3004 19.6001 13.9004 20.4001 13.4004 20.7001L12.0004 21.6001C10.7004 22.4001 8.90039 21.5001 8.90039 19.9001V14.6001C8.90039 13.9001 8.50039 13.0001 8.10039 12.5001L4.30039 8.5001C3.80039 8.0001 3.40039 7.1001 3.40039 6.5001V4.2001C3.40039 3.0001 4.30039 2.1001 5.40039 2.1001Z"
        fill={color}
      />
    </svg>
  );
};
export const Excel = () => {
  return (
    <img
      src="/icons/IconButton2.svg"
      alt="excel"
      className="cursor-pointer h-[44px] object-cover"
    />
  );
};
export const Icon2 = ({ onClick, listView }) => {
  return (
    <Fragment>
      {!listView ? (
        <IconButton3Icon
          className="cursor-pointer h-[44px] w-[44px]"
          onClick={onClick}
        />
      ) : (
        <img
          src="/icons/IconButton-grey.svg"
          alt="icon"
          className="cursor-pointer h-[44px] object-cover"
          onClick={onClick}
        />
      )}
    </Fragment>
  );
};
export const Icon3 = ({ onClick, listView }) => {
  return (
    <Fragment>
      {!listView ? (
        <img
          src="/icons/IconButton4.svg"
          alt="icon"
          className="cursor-pointer h-[44px] object-cover"
          onClick={onClick}
        />
      ) : (
        <IconButtonBlueIcon
          className="cursor-pointer h-[44px] w-[44px]"
          onClick={onClick}
        />
      )}
    </Fragment>
  );
};

export const TableArrow = () => {
  return (
    <img
      src="/icons/table-arrow.svg"
      alt="icon"
      className="cursor-pointer rev-rotate"
    />
  );
};
export const AngleSmall = () => {
  return (
    <img
      src="/icons/fi-br-angle-small-down.svg"
      alt="icon"
      className="cursor-pointer rev-rotate"
    />
  );
};

export const CardsIcon1 = () => {
  return (
    <img
      src="/icons/cards-icon1.svg"
      alt="icon"
      className="cursor-pointer w-[41px] h-[41px]"
    />
  );
};
export const CardsIcon2 = () => {
  return (
    <img
      src="/icons/card-icon-1.svg"
      alt="icon"
      className="cursor-pointer w-[41px] h-[41px]"
    />
  );
};
export const CardsIcon3 = () => {
  return (
    <img
      src="/icons/card-icon-2.svg"
      alt="icon"
      className="cursor-pointer w-[41px] h-[41px]"
    />
  );
};
export const CardsIcon4 = () => {
  return (
    <img
      src="/icons/card-icon-3.svg"
      alt="icon"
      className="cursor-pointer w-[41px] h-[41px]"
    />
  );
};
export const Edit = () => {
  return (
    <img
      src="/icons/Edit.svg"
      alt="icon"
      className="cursor-pointer absolute left-6 top-6 Edit"
    />
  );
};
export const TableDots = () => {
  return (
    <img src="/icons/table-dots.svg" alt="icon" className="cursor-pointer" />
  );
};
export const SettingArrow = ({ active }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      className="st-arrow"
    >
      <path
        d="M8.5 15L1.5 8L8.5 1"
        stroke={active ? "rgb(var(--color-primary))" : "#0A0A0A"}
        strokeWidth={active ? "2" : "1"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = (props) => {
  return (
    <img
      src="/icons/delete-icon.svg"
      className="w-[18.46px] h-5 relative"
      alt=""
    />
  );
};
export const XIcon = (props) => {
  return <p className="text-[red]">X</p>;
};
export const HelpCenter = () => {
  return <img src="/icons/pay.svg" alt="" />;
};

const CARD_NETWORK_LOGOS = [
  {
    type: CARD_TYPES.MADA,
    src: "/icons/meda-icon.svg",
    alt: "mada",
    className: "h-4 w-auto object-contain",
  },
  {
    type: CARD_TYPES.VISA,
    src: "/icons/visa-icon.png",
    alt: "visa",
    className: "h-3.5 w-auto object-contain",
  },
  {
    type: CARD_TYPES.MASTERCARD,
    src: "/icons/master-card-icon.svg",
    alt: "mastercard",
    className: "h-4 w-auto object-contain",
  },
];

export const CardNumberPaymentSuffix = ({ cardNumber, cardType: explicitType }) => {
  const detectedType = explicitType || detectCardType(cardNumber);
  const normalizedType =
    typeof detectedType === "string" ? detectedType.toUpperCase() : null;

  const getLogoStyle = (type) => {
    if (!normalizedType || normalizedType === CARD_TYPES.UNKNOWN) {
      return "opacity-70 transition-all duration-200";
    }
    if (normalizedType === type) {
      return "opacity-100 scale-110 drop-shadow-sm transition-all duration-200";
    }
    return "opacity-20 grayscale transition-all duration-200";
  };

  return (
    <div className="flex items-center gap-1.5 shrink-0" aria-hidden>
      {CARD_NETWORK_LOGOS.map((card) => (
        <img
          key={card.type}
          src={card.src}
          alt={card.alt}
          className={`${card.className} ${getLogoStyle(card.type)}`}
        />
      ))}
    </div>
  );
};

export const Accounts = () => {
  return <img src="/icons/accounts.svg" alt="" />;
};
export const Missions = () => {
  return <img src="/icons/missions.svg" alt="" />;
};
export const EditIcon = (props) => {
  return (
    <img
      src="/icons/Edit-Square.svg"
      alt="icon"
      className="cursor-pointer"
      {...props}
    />
  );
};

export const TrueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2315_11710)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 3.00012C3.89543 3.00012 3 3.89555 3 5.00012V19.0001C3 20.1047 3.89543 21.0001 5 21.0001H19C20.1046 21.0001 21 20.1047 21 19.0001V5.00012C21 3.89555 20.1046 3.00012 19 3.00012H5ZM16.9498 9.79566C17.3403 9.40514 17.3403 8.77197 16.9498 8.38145C16.5593 7.99093 15.9261 7.99093 15.5356 8.38145L10.5858 13.3312L8.46452 11.2099C8.07401 10.8193 7.44084 10.8193 7.05031 11.2098C6.65977 11.6003 6.65975 12.2335 7.05026 12.624L9.80789 15.3818C10.2375 15.8114 10.934 15.8115 11.3636 15.3819L16.9498 9.79566Z"
          fill="rgb(var(--color-primary))"
        />
      </g>
      <defs>
        <clipPath id="clip0_2315_11710">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RemoveFilters = ({ className = "", ...props }) => {
  const { t } = useTranslation();
  return (
    <div
      {...props}
      className={`cursor-pointer flex h-[43px] px-[19px] py-[9px] justify-center items-center gap-[7px] rounded-[6px] border-[1px] border-[solid] border-[#FF6868] bg-[#F1F1F2] ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_3385_16469)">
          <path
            d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM9.879 8.464L12 10.586L14.121 8.464C14.2139 8.37109 14.3242 8.29739 14.4456 8.24711C14.567 8.19682 14.6971 8.17094 14.8285 8.17094C14.9599 8.17094 15.09 8.19682 15.2114 8.24711C15.3328 8.29739 15.4431 8.37109 15.536 8.464C15.6289 8.55691 15.7026 8.66721 15.7529 8.7886C15.8032 8.91 15.8291 9.04011 15.8291 9.1715C15.8291 9.3029 15.8032 9.433 15.7529 9.5544C15.7026 9.67579 15.6289 9.78609 15.536 9.879L13.414 11.999L15.536 14.121C15.7236 14.3086 15.8291 14.5631 15.8291 14.8285C15.8291 15.0939 15.7236 15.3484 15.536 15.536C15.3484 15.7236 15.0939 15.8291 14.8285 15.8291C14.5631 15.8291 14.3086 15.7236 14.121 15.536L12 13.414L9.879 15.536C9.69136 15.7236 9.43686 15.8291 9.1715 15.8291C8.90614 15.8291 8.65164 15.7236 8.464 15.536C8.27636 15.3484 8.17094 15.0939 8.17094 14.8285C8.17094 14.5631 8.27636 14.3086 8.464 14.121L10.586 12L8.465 9.879C8.27736 9.69149 8.17189 9.43712 8.1718 9.17185C8.1717 8.90658 8.27699 8.65214 8.4645 8.4645C8.65201 8.27686 8.90638 8.17139 9.17165 8.1713C9.43692 8.1712 9.69136 8.27649 9.879 8.464Z"
            fill="#FF6868"
          />
        </g>
        <defs>
          <clipPath id="clip0_3385_16469">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <p className="text-[#FF6868] text-right text-[13px] not-italic font-medium leading-[14px]">
        {t("remove_filters")}
      </p>
    </div>
  );
};
export const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_3431_19118)">
        <path
          d="M7.00033 1.16602C10.2221 1.16602 12.8337 3.7776 12.8337 6.99935C12.8337 10.2211 10.2221 12.8327 7.00033 12.8327C3.77858 12.8327 1.16699 10.2211 1.16699 6.99935C1.16699 3.7776 3.77858 1.16602 7.00033 1.16602ZM7.00033 2.33268C5.76265 2.33268 4.57566 2.82435 3.70049 3.69952C2.82532 4.57469 2.33366 5.76167 2.33366 6.99935C2.33366 8.23703 2.82532 9.42401 3.70049 10.2992C4.57566 11.1744 5.76265 11.666 7.00033 11.666C8.238 11.666 9.42499 11.1744 10.3002 10.2992C11.1753 9.42401 11.667 8.23703 11.667 6.99935C11.667 5.76167 11.1753 4.57469 10.3002 3.69952C9.42499 2.82435 8.238 2.33268 7.00033 2.33268ZM6.99449 5.83268C7.31999 5.83268 7.58366 6.09635 7.58366 6.42185V9.41085C7.69486 9.47506 7.78177 9.57417 7.8309 9.6928C7.88004 9.81143 7.88866 9.94296 7.85542 10.067C7.82219 10.191 7.74896 10.3006 7.64709 10.3788C7.54522 10.457 7.4204 10.4993 7.29199 10.4993H7.00616C6.92879 10.4993 6.85218 10.4841 6.78069 10.4545C6.70921 10.4249 6.64426 10.3815 6.58956 10.3268C6.53485 10.2721 6.49145 10.2071 6.46184 10.1356C6.43223 10.0642 6.41699 9.98755 6.41699 9.91018V6.99935C6.26228 6.99935 6.11391 6.93789 6.00451 6.8285C5.89512 6.7191 5.83366 6.57073 5.83366 6.41602C5.83366 6.26131 5.89512 6.11293 6.00451 6.00354C6.11391 5.89414 6.26228 5.83268 6.41699 5.83268H6.99449ZM7.00033 4.08268C7.15504 4.08268 7.30341 4.14414 7.4128 4.25354C7.5222 4.36293 7.58366 4.51131 7.58366 4.66602C7.58366 4.82073 7.5222 4.9691 7.4128 5.07849C7.30341 5.18789 7.15504 5.24935 7.00033 5.24935C6.84562 5.24935 6.69724 5.18789 6.58785 5.07849C6.47845 4.9691 6.41699 4.82073 6.41699 4.66602C6.41699 4.51131 6.47845 4.36293 6.58785 4.25354C6.69724 4.14414 6.84562 4.08268 7.00033 4.08268Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3431_19118">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TaskIcon = () => {
  return (
    <div className="w-[24px] h-[24px] flex-shrink-0 opacity-50">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g opacity="0.5" clipPath="url(#clip0_3532_4674)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6H14C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4ZM9.354 3C10.059 2.378 10.986 2 12 2C13.014 2 13.94 2.378 14.646 3H18C18.5304 3 19.0391 3.21071 19.4142 3.58579C19.7893 3.96086 20 4.46957 20 5V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V5C4 4.46957 4.21071 3.96086 4.58579 3.58579C4.96086 3.21071 5.46957 3 6 3H9.354ZM8.126 5H6V20H18V5H15.874C15.956 5.32 16 5.655 16 6V7C16 7.26522 15.8946 7.51957 15.7071 7.70711C15.5196 7.89464 15.2652 8 15 8H9C8.73478 8 8.48043 7.89464 8.29289 7.70711C8.10536 7.51957 8 7.26522 8 7V6C8 5.655 8.044 5.32 8.126 5ZM8 11C8 10.7348 8.10536 10.4804 8.29289 10.2929C8.48043 10.1054 8.73478 10 9 10H15C15.2652 10 15.5196 10.1054 15.7071 10.2929C15.8946 10.4804 16 10.7348 16 11C16 11.2652 15.8946 11.5196 15.7071 11.7071C15.5196 11.8946 15.2652 12 15 12H9C8.73478 12 8.48043 11.8946 8.29289 11.7071C8.10536 11.5196 8 11.2652 8 11ZM8 15C8 14.7348 8.10536 14.4804 8.29289 14.2929C8.48043 14.1054 8.73478 14 9 14H12C12.2652 14 12.5196 14.1054 12.7071 14.2929C12.8946 14.4804 13 14.7348 13 15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16H9C8.73478 16 8.48043 15.8946 8.29289 15.7071C8.10536 15.5196 8 15.2652 8 15Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_3532_4674">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const TaskIcon2 = () => {
  return (
    <div className="w-[10px] h-[10px] rotate-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="11"
        viewBox="0 0 10 11"
        fill="none"
      >
        <path
          d="M6.24025 8.37134L6.24024 8.37135C6.14179 8.46978 6.00828 8.52507 5.86907 8.52507C5.72986 8.52507 5.59635 8.46978 5.4979 8.37136C5.4979 8.37136 5.49789 8.37136 5.49789 8.37135L3.58707 6.46053L3.58707 6.46053C3.46092 6.33439 3.36085 6.18465 3.29258 6.01984C3.22431 5.85503 3.18917 5.67838 3.18917 5.49999C3.18917 5.3216 3.22431 5.14496 3.29258 4.98015C3.36085 4.81534 3.46092 4.66559 3.58707 4.53946L3.58707 4.53945L5.49788 2.62864C5.59637 2.53019 5.72994 2.47491 5.86919 2.47494C6.00844 2.47497 6.14198 2.53032 6.24042 2.62881C6.33887 2.7273 6.39415 2.86086 6.39412 3.00012C6.39409 3.13937 6.33874 3.2729 6.24025 3.37135L6.24023 3.37136L4.32981 5.28178L4.3298 5.28179C4.272 5.33961 4.23953 5.41802 4.23953 5.49978C4.23953 5.58154 4.272 5.65995 4.3298 5.71778L4.32981 5.71778L6.24022 7.62861L6.24025 7.62864C6.28904 7.6774 6.32774 7.73529 6.35414 7.79901C6.38055 7.86272 6.39414 7.93102 6.39414 7.99999C6.39414 8.06896 6.38055 8.13726 6.35415 8.20098C6.32774 8.2647 6.28904 8.32259 6.24025 8.37134Z"
          fill="#757575"
          stroke="white"
          strokeWidth="0.2"
        />
      </svg>
    </div>
  );
};
export const UploadAttachmednts = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
    >
      <path
        d="M4.33343 17.2412C3.68124 17.245 3.03785 17.0905 2.45843 16.7912C1.92861 16.519 1.4633 16.1365 1.09386 15.6693C0.724411 15.2021 0.459425 14.6611 0.316761 14.0828C0.0121573 12.8787 0.166629 11.6043 0.750095 10.5078L3.76676 4.67449C3.84301 4.52641 3.97496 4.41469 4.13359 4.3639C4.29221 4.31311 4.46452 4.32741 4.61259 4.40366C4.76067 4.47991 4.8724 4.61186 4.92319 4.77048C4.97398 4.92911 4.95968 5.10141 4.88343 5.24949L1.83343 11.0828C1.39633 11.9059 1.27766 12.8611 1.50009 13.7662C1.59951 14.1718 1.78489 14.5513 2.04367 14.8791C2.30245 15.2069 2.62862 15.4753 3.00009 15.6662C3.39944 15.8474 3.83061 15.948 4.2689 15.9623C4.7072 15.9765 5.144 15.9042 5.55429 15.7494C5.96458 15.5945 6.34029 15.3603 6.65988 15.06C6.97948 14.7597 7.23668 14.3993 7.41676 13.9995L10.6584 7.77449C10.6954 7.70208 10.7464 7.63769 10.8084 7.58505C10.8704 7.53241 10.9422 7.49255 11.0196 7.46777C11.0971 7.44298 11.1787 7.43376 11.2597 7.44064C11.3407 7.44751 11.4196 7.47035 11.4918 7.50783C11.6364 7.5842 11.7454 7.71424 11.7952 7.87005C11.8451 8.02585 11.8319 8.19499 11.7584 8.34116L8.50009 14.5495C8.11072 15.3305 7.51849 15.9925 6.78544 16.466C6.05239 16.9396 5.20548 17.2073 4.33343 17.2412Z"
        fill="#A1A5B7"
      />
      <path
        d="M8.3834 9.83254C8.28143 9.83238 8.18113 9.80659 8.09173 9.75754C7.94861 9.67962 7.84103 9.54953 7.79136 9.39433C7.7417 9.23912 7.75377 9.07074 7.82506 8.92421L9.65006 5.40754C9.956 4.83859 10.0392 4.17613 9.8834 3.54921C9.81814 3.27305 9.69534 3.01377 9.52302 2.78832C9.3507 2.56287 9.13275 2.37632 8.8834 2.24087C8.62693 2.10994 8.34511 2.03617 8.05738 2.02466C7.76965 2.01315 7.48284 2.06417 7.21673 2.17421C6.61367 2.40789 6.1181 2.85598 5.82506 3.43254L4.04173 6.88254C4.00343 6.95532 3.95117 7.01983 3.88793 7.07241C3.8247 7.12499 3.75172 7.16459 3.67318 7.18897C3.51456 7.2382 3.34287 7.2224 3.1959 7.14504C3.12312 7.10674 3.05861 7.05448 3.00603 6.99124C2.95345 6.92801 2.91384 6.85503 2.88947 6.77649C2.84024 6.61787 2.85604 6.44618 2.9334 6.29921L4.7334 2.83254C5.17815 1.97366 5.92679 1.31117 6.8334 0.974208C7.26101 0.803727 7.72031 0.727265 8.18009 0.750014C8.63987 0.772763 9.08938 0.894189 9.49807 1.10605C9.90677 1.31791 10.2651 1.61524 10.5487 1.97784C10.8323 2.34045 11.0346 2.75984 11.1417 3.20754C11.373 4.13673 11.2544 5.11853 10.8084 5.96587L8.97506 9.47421C8.92357 9.58624 8.83967 9.68027 8.7342 9.74414C8.62874 9.80802 8.50654 9.83881 8.3834 9.83254Z"
        fill="#A1A5B7"
      />
      <path
        d="M5.43336 13.3662C5.08186 13.3665 4.73564 13.2807 4.42502 13.1162C3.87118 12.7994 3.4639 12.2778 3.29089 11.6637C3.11787 11.0496 3.19298 10.3921 3.50002 9.83283L5.84169 5.33283C5.92232 5.19387 6.05336 5.09129 6.20762 5.04639C6.36187 5.00149 6.5275 5.01772 6.67011 5.0917C6.81272 5.16569 6.92136 5.29175 6.97348 5.44372C7.02561 5.59569 7.0172 5.76189 6.95002 5.90783L4.60836 10.4162C4.44673 10.6797 4.39545 10.9963 4.46565 11.2973C4.53584 11.5984 4.72185 11.8596 4.98336 12.0245C5.11363 12.0861 5.25593 12.118 5.40002 12.118C5.54412 12.118 5.68642 12.0861 5.81669 12.0245C6.12784 11.8998 6.38271 11.6656 6.53336 11.3662L8.10836 8.34117C8.18898 8.2022 8.32003 8.09962 8.47428 8.05472C8.62854 8.00982 8.79417 8.02605 8.93678 8.10003C9.07939 8.17402 9.18803 8.30008 9.24015 8.45205C9.29227 8.60402 9.28387 8.77023 9.21669 8.91617L7.66669 11.9578C7.37331 12.5322 6.87751 12.9776 6.27502 13.2078C6.00731 13.3144 5.7215 13.3682 5.43336 13.3662Z"
        fill="#A1A5B7"
      />
    </svg>
  );
};
export const Gold = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="VIP_2_line" clipPath="url(#clip0_4408_14006)">
        <g id="Group">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2811 5.04417C10.5853 4.87162 10.8238 4.60323 10.9594 4.28087C11.095 3.95851 11.1201 3.60032 11.0307 3.26223C10.9413 2.92413 10.7425 2.62514 10.4652 2.41193C10.188 2.19872 9.84805 2.08328 9.49833 2.08363C9.14862 2.08399 8.80886 2.20012 8.53208 2.41389C8.25531 2.62766 8.0571 2.92706 7.96839 3.26533C7.87968 3.60361 7.90546 3.96174 8.04171 4.28383C8.17796 4.60591 8.41701 4.87383 8.72155 5.04575L8.71363 5.06C8.19509 6.14221 7.47467 7.69229 6.36238 8.27417C5.4488 8.75154 4.1378 8.51167 3.16405 8.33275C3.14843 8.11133 3.07106 7.89872 2.94072 7.71905C2.81039 7.53937 2.6323 7.39982 2.42667 7.31623C2.22104 7.23265 1.9961 7.20837 1.77737 7.24615C1.55863 7.28393 1.35487 7.38226 1.18919 7.52999C1.02352 7.67771 0.902564 7.86891 0.840054 8.0819C0.777543 8.29489 0.77598 8.52113 0.835541 8.73496C0.895103 8.94879 1.0134 9.14165 1.17702 9.29165C1.34064 9.44165 1.54303 9.54279 1.76121 9.58359L4.09505 15.6082C4.26813 16.0548 4.57221 16.4387 4.96738 16.7094C5.36255 16.9801 5.83034 17.125 6.30934 17.125H12.6902C13.1692 17.125 13.637 16.9801 14.0321 16.7094C14.4273 16.4387 14.7314 16.0548 14.9045 15.6082L17.2375 9.58359C17.4543 9.54323 17.6556 9.4433 17.8188 9.29499C17.982 9.14668 18.1007 8.95585 18.1616 8.74388C18.2225 8.53191 18.2231 8.30717 18.1634 8.09486C18.1038 7.88255 17.9862 7.69104 17.8238 7.54181C17.6614 7.39258 17.4607 7.29151 17.2441 7.24993C17.0275 7.20835 16.8036 7.2279 16.5976 7.3064C16.3915 7.3849 16.2113 7.51924 16.0773 7.69436C15.9432 7.86949 15.8606 8.07848 15.8386 8.29792C14.8419 8.42696 13.557 8.59163 12.6371 8.11109C11.547 7.54109 10.8163 6.09788 10.2811 5.04417ZM9.51955 6.91804C10.1275 7.90446 10.8567 8.96609 11.904 9.51471C12.9546 10.0633 14.2474 10.0356 15.4032 9.93667L13.428 15.0358C13.3704 15.1847 13.2691 15.3127 13.1374 15.4029C13.0057 15.4932 12.8498 15.5416 12.6902 15.5417H6.30934C6.14969 15.5416 5.99379 15.4932 5.86212 15.4029C5.73044 15.3127 5.62914 15.1847 5.57151 15.0358L3.62321 10.0063C4.76242 10.152 6.05126 10.2233 7.09546 9.677C8.18638 9.107 8.9163 7.9575 9.51955 6.91804Z"
            fill="#CBB406"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4408_14006">
          <rect
            width="19"
            height="19"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Correct = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0_4408_14424)">
        <path
          d="M8.75977 1.34991C4.62377 1.34991 1.25977 4.71391 1.25977 8.84991C1.25977 12.9849 4.62377 16.3499 8.75977 16.3499C12.8958 16.3499 16.2598 12.9849 16.2598 8.84991C16.2598 4.71391 12.8958 1.34991 8.75977 1.34991Z"
          fill="#E8F6E6"
        />
        <path
          d="M11.7119 7.6219L8.39188 10.9399C8.29625 11.0355 8.16658 11.0891 8.03138 11.0891C7.89618 11.0891 7.76652 11.0355 7.67088 10.9399L6.00988 9.2809C5.96248 9.23349 5.92487 9.17721 5.89921 9.11527C5.87356 9.05333 5.86035 8.98694 5.86035 8.9199C5.86035 8.85285 5.87356 8.78647 5.89921 8.72452C5.92487 8.66258 5.96248 8.6063 6.00988 8.5589C6.05729 8.51149 6.11357 8.47388 6.17551 8.44823C6.23745 8.42257 6.30384 8.40937 6.37088 8.40937C6.43793 8.40937 6.50431 8.42257 6.56625 8.44823C6.62819 8.47388 6.68448 8.51149 6.73188 8.5589L8.03088 9.8579L10.9899 6.8999C11.0373 6.85249 11.0936 6.81488 11.1555 6.78923C11.2175 6.76357 11.2838 6.75037 11.3509 6.75037C11.4179 6.75037 11.4843 6.76357 11.5463 6.78923C11.6082 6.81488 11.6645 6.85249 11.7119 6.8999C11.7593 6.9473 11.7969 7.00359 11.8226 7.06553C11.8482 7.12747 11.8614 7.19385 11.8614 7.2609C11.8614 7.32794 11.8482 7.39433 11.8226 7.45627C11.7969 7.51821 11.7593 7.57449 11.7119 7.6219Z"
          fill="#62BC55"
          stroke="#62BC55"
          strokeWidth="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_4408_14424">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.759766 0.649902)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Visa = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="12"
      viewBox="0 0 36 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1806 0.679745L9.59842 11.7874H6.60886L4.35391 2.92367C4.21702 2.37767 4.09871 2.17775 3.68163 1.9477C3.00186 1.57299 1.87932 1.2215 0.892578 1.00312L0.959661 0.680276H5.77213C6.38554 0.680276 6.93698 1.09518 7.07624 1.81279L8.26715 8.23953L11.2104 0.679321H14.1818L14.1806 0.679745ZM25.8943 8.16084C25.9064 5.22922 21.9043 5.0679 21.9318 3.75805C21.9404 3.35947 22.3146 2.93576 23.1315 2.82758C23.5368 2.7737 24.6533 2.73255 25.9206 3.32468L26.4173 0.969185C25.7368 0.718246 24.8612 0.476746 23.7719 0.476746C20.9765 0.476746 19.0091 1.98652 18.9926 4.14846C18.9743 5.74753 20.3962 6.63993 21.4683 7.17129C22.5706 7.71538 22.9405 8.06506 22.9362 8.55177C22.9284 9.29685 22.0571 9.62606 21.2428 9.63879C19.8209 9.66106 18.9964 9.24796 18.3389 8.93741L17.8263 11.3709C18.4871 11.6789 19.7068 11.9476 20.9714 11.9611C23.9426 11.9611 25.8851 10.47 25.8943 8.16084ZM33.2769 11.7874H35.8926L33.6082 0.679745H31.1942C30.9364 0.677518 30.6839 0.753988 30.4693 0.899291C30.2548 1.04459 30.0882 1.25194 29.9911 1.49461L25.7472 11.7874H28.7169L29.306 10.1283H32.9346L33.2769 11.7874ZM30.1212 7.85178L31.6099 3.68126L32.4666 7.85178H30.1212ZM18.2215 0.679745L15.8829 11.7874H13.0548L15.3944 0.679745H18.2215Z"
        fill="#2E4999"
      />
    </svg>
  );
};
export const Mastercard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="36"
      viewBox="0 0 41 36"
      fill="none"
    >
      <path
        d="M24.6846 10.4079H16.1016V25.8318H24.6846V10.4079Z"
        fill="#FF5F00"
      />
      <path
        d="M16.6438 18.1192C16.6425 16.6338 16.9791 15.1675 17.6283 13.8314C18.2773 12.4953 19.2218 11.3243 20.3904 10.4072C18.9434 9.26984 17.2055 8.5625 15.3754 8.36608C13.5454 8.16966 11.697 8.49208 10.0416 9.2965C8.3861 10.1009 6.99036 11.3549 6.01386 12.915C5.03737 14.4752 4.51953 16.2786 4.51953 18.1192C4.51953 19.9598 5.03737 21.7632 6.01386 23.3233C6.99036 24.8835 8.3861 26.1375 10.0416 26.9418C11.697 27.7462 13.5454 28.0686 15.3754 27.8722C17.2055 27.6758 18.9434 26.9685 20.3904 25.8311C19.2218 24.9141 18.2774 23.7431 17.6283 22.4069C16.9791 21.0709 16.6425 19.6046 16.6438 18.1192Z"
        fill="#EB001B"
      />
      <path
        d="M36.263 18.1192C36.263 19.9596 35.7453 21.7631 34.7689 23.3233C33.7924 24.8835 32.3967 26.1373 30.7413 26.9418C29.0859 27.7462 27.2374 28.0686 25.4074 27.8722C23.5774 27.6758 21.8396 26.9685 20.3926 25.8311C21.5601 24.9131 22.5039 23.7419 23.1529 22.4061C23.8019 21.0702 24.1392 19.6043 24.1392 18.1192C24.1392 16.6339 23.8019 15.1682 23.1529 13.8323C22.5039 12.4964 21.5601 11.3253 20.3926 10.4072C21.8396 9.26983 23.5774 8.56251 25.4074 8.36608C27.2374 8.16966 29.0859 8.49209 30.7413 9.29652C32.3967 10.1009 33.7924 11.3549 34.7689 12.9151C35.7453 14.4752 36.263 16.2786 36.263 18.1192Z"
        fill="#F79E1B"
      />
      <path
        d="M35.322 24.1993V23.8835H35.4493V23.8192H35.125V23.8835H35.2524V24.1993H35.322ZM35.9516 24.1993V23.8186H35.8521L35.7379 24.0805L35.6234 23.8186H35.524V24.1993H35.5941V23.9121L35.7014 24.1598H35.7741L35.8814 23.9115V24.1993H35.9516Z"
        fill="#F79E1B"
      />
    </svg>
  );
};
export const Download = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <g clipPath="url(#clip0_4439_17020)">
        <path
          d="M15 11.75C15.1989 11.75 15.3897 11.829 15.5303 11.9697C15.671 12.1103 15.75 12.3011 15.75 12.5V15.5C15.75 15.8978 15.592 16.2794 15.3107 16.5607C15.0294 16.842 14.6478 17 14.25 17H3.75C3.35218 17 2.97064 16.842 2.68934 16.5607C2.40804 16.2794 2.25 15.8978 2.25 15.5V12.5C2.25 12.3011 2.32902 12.1103 2.46967 11.9697C2.61032 11.829 2.80109 11.75 3 11.75C3.19891 11.75 3.38968 11.829 3.53033 11.9697C3.67098 12.1103 3.75 12.3011 3.75 12.5V15.5H14.25V12.5C14.25 12.3011 14.329 12.1103 14.4697 11.9697C14.6103 11.829 14.8011 11.75 15 11.75ZM9 2C9.19891 2 9.38968 2.07902 9.53033 2.21967C9.67098 2.36032 9.75 2.55109 9.75 2.75V10.4323L11.652 8.53025C11.7212 8.45862 11.8039 8.40148 11.8954 8.36217C11.9869 8.32287 12.0854 8.30218 12.1849 8.30131C12.2845 8.30045 12.3833 8.31942 12.4755 8.35713C12.5676 8.39484 12.6514 8.45053 12.7218 8.52095C12.7922 8.59137 12.8479 8.67511 12.8856 8.76728C12.9233 8.85946 12.9423 8.95822 12.9414 9.0578C12.9406 9.15739 12.9199 9.2558 12.8806 9.3473C12.8413 9.43881 12.7841 9.52156 12.7125 9.59075L9.663 12.6403C9.57594 12.7273 9.47258 12.7964 9.35882 12.8435C9.24506 12.8907 9.12314 12.9149 9 12.9149C8.87686 12.9149 8.75494 12.8907 8.64118 12.8435C8.52742 12.7964 8.42406 12.7273 8.337 12.6403L5.2875 9.59075C5.21587 9.52156 5.15873 9.43881 5.11942 9.3473C5.08012 9.2558 5.05943 9.15739 5.05856 9.0578C5.0577 8.95822 5.07667 8.85946 5.11438 8.76728C5.15209 8.67511 5.20778 8.59137 5.2782 8.52095C5.34862 8.45053 5.43236 8.39484 5.52453 8.35713C5.61671 8.31942 5.71547 8.30045 5.81505 8.30131C5.91464 8.30218 6.01305 8.32287 6.10455 8.36217C6.19606 8.40148 6.27881 8.45862 6.348 8.53025L8.25 10.4323V2.75C8.25 2.55109 8.32902 2.36032 8.46967 2.21967C8.61032 2.07902 8.80109 2 9 2Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4439_17020">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Right = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      className="mx-auto mb-3"
    >
      <g clipPath="url(#clip0_4408_15141)">
        <path
          d="M30.0008 13.4211C39.157 13.4211 46.5798 20.8437 46.5798 30C46.5798 39.1562 39.157 46.5789 30.0008 46.5789C20.8445 46.5789 13.4219 39.1562 13.4219 30C13.4219 20.8437 20.8445 13.4211 30.0008 13.4211ZM35.8621 24.0007L27.6559 32.2068L24.139 28.6899C23.4916 28.0425 22.4419 28.0425 21.7944 28.6899C21.147 29.3373 21.147 30.3871 21.7944 31.0345L26.3664 35.6065C27.0786 36.3187 28.2333 36.3187 28.9456 35.6065L38.2067 26.3453C38.8541 25.6978 38.8541 24.6481 38.2067 24.0007C37.5593 23.3532 36.5096 23.3532 35.8621 24.0007Z"
          fill="rgb(var(--color-primary))"
        />
      </g>
      <defs>
        <clipPath id="clip0_4408_15141">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UnitLocation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      className="relative top-1 shrink-0"
    >
      <g clipPath="url(#clip0_6189_335)">
        <path
          d="M12.908 1.71843C11.693 0.610923 10.0744 0.000980302 8.35024 0.000980302H8.3428C4.87086 -0.0635192 1.82489 2.71174 1.89638 5.8619C1.98726 8.0863 4.34489 10.9112 6.18088 13.0816C6.72006 13.6662 7.50569 13.9999 8.3497 13.9999C9.22329 13.9999 10.0344 13.6426 10.575 13.0196C11.937 11.4834 14.878 7.78844 14.7893 5.86185C14.7893 4.29579 14.1212 2.8243 12.908 1.71843ZM9.62845 12.3429C9.00582 13.0883 7.69607 13.0897 7.0732 12.3442C4.58369 9.4669 3.10127 7.07074 3.10127 5.86188C3.10127 3.23323 5.45261 1.09468 8.3428 1.09468H8.35024C11.2363 1.09468 13.5843 3.23326 13.5843 5.86188C13.5843 7.08389 12.1425 9.44612 9.62845 12.3429ZM8.37666 8.17612C6.96479 8.17612 5.81614 7.13355 5.81614 5.85206C5.95679 2.76888 10.797 2.76978 10.9372 5.85209C10.9372 7.13357 9.78853 8.17612 8.37666 8.17612ZM8.37666 4.62168C7.6292 4.62168 7.02109 5.17363 7.02109 5.85206C7.09556 7.48434 9.65803 7.48385 9.73223 5.85206C9.73223 5.17363 9.12415 4.62168 8.37666 4.62168Z"
          fill="rgb(var(--color-brand-strong))"
        />
      </g>
      <defs>
        <clipPath id="clip0_6189_335">
          <rect
            width="15.4244"
            height="14"
            fill="white"
            transform="translate(0.630859 -0.000183105)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Home = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
    >
      <g clipPath="url(#clip0_6189_354)">
        <path
          d="M8.34307 0.326904L0.630859 6.40586L1.42034 7.23098L2.14236 6.66185V12.0336C2.14236 12.9375 2.95254 13.6728 3.9484 13.6728H7.31966V8.31795H9.42669V13.6728H12.7378C13.7336 13.6728 14.5438 12.9375 14.5438 12.0336V6.66188L15.2658 7.23101L16.0553 6.40588L8.34307 0.326904ZM13.3398 12.0336C13.3398 12.3349 13.0697 12.58 12.7378 12.58H10.6307V7.22513H6.11563V12.58H3.94837C3.61642 12.58 3.34637 12.3349 3.34637 12.0336V5.71283L8.34307 1.77432L13.3398 5.71283V12.0336Z"
          fill="rgb(var(--color-brand-strong))"
        />
      </g>
      <defs>
        <clipPath id="clip0_6189_354">
          <rect
            width="15.4244"
            height="14"
            fill="white"
            transform="translate(0.630859 -0.000183105)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NavCalendar = ({ isDark }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
    >
      <path
        d="M8 15H16M8 3V7M12 3V7M16 3V7M10 11H16M19.9 21H4.1C4.04477 21 4 20.9552 4 20.9V5.1C4 5.04477 4.04477 5 4.1 5H19.9C19.9552 5 20 5.04477 20 5.1V20.9C20 20.9552 19.9552 21 19.9 21Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Calendar = ({ isDark }) => {
  return (
    <MaskIcon src="/icons/calendar-2.svg" className="h-[14px] w-4 bg-brand" />
  );
};
export const Calendar2 = ({ active }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      className="shrink-0 relative top-[1.7px]"
    >
      <g clipPath="url(#clip0_6330_30398)">
        <path
          d="M10 1.875C10.1531 1.87502 10.3008 1.93122 10.4152 2.03295C10.5296 2.13467 10.6027 2.27484 10.6206 2.42687L10.625 2.5V3.125H11.875C12.1904 3.1249 12.4941 3.244 12.7253 3.45844C12.9566 3.67287 13.0982 3.96678 13.1219 4.28125L13.125 4.375V11.875C13.1251 12.1904 13.006 12.4941 12.7916 12.7253C12.5771 12.9566 12.2832 13.0982 11.9688 13.1219L11.875 13.125H3.125C2.80964 13.1251 2.5059 13.006 2.27466 12.7916C2.04342 12.5771 1.90178 12.2832 1.87813 11.9688L1.875 11.875V4.375C1.8749 4.05964 1.994 3.7559 2.20844 3.52466C2.42287 3.29342 2.71678 3.15178 3.03125 3.12813L3.125 3.125H4.375V2.5C4.37518 2.3407 4.43617 2.18748 4.54553 2.07164C4.65489 1.95581 4.80435 1.8861 4.96337 1.87677C5.1224 1.86743 5.27899 1.91917 5.40115 2.02142C5.5233 2.12366 5.60181 2.26869 5.62063 2.42687L5.625 2.5V3.125H9.375V2.5C9.375 2.33424 9.44085 2.17527 9.55806 2.05806C9.67527 1.94085 9.83424 1.875 10 1.875ZM11.875 7.5H3.125V11.875H11.875V7.5ZM11.875 4.375H3.125V6.25H11.875V4.375Z"
          fill={active ? "rgb(var(--color-primary))" : "#1F2A37"}
        />
      </g>
      <defs>
        <clipPath id="clip0_6330_30398">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ChevronUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_6659_2304)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.46515 14.207C8.65268 14.3945 8.90699 14.4998 9.17215 14.4998C9.43731 14.4998 9.69162 14.3945 9.87915 14.207L12.0001 12.086L14.1212 14.207C14.3087 14.3947 14.563 14.5002 14.8283 14.5002C15.0936 14.5003 15.348 14.3951 15.5356 14.2075C15.7233 14.02 15.8288 13.7657 15.8289 13.5004C15.8289 13.2351 15.7237 12.9807 15.5361 12.793L12.7071 9.96404C12.5196 9.77657 12.2653 9.67126 12.0001 9.67126C11.735 9.67126 11.4807 9.77657 11.2931 9.96404L8.46515 12.793C8.27768 12.9806 8.17236 13.2349 8.17236 13.5C8.17236 13.7652 8.27768 14.0195 8.46515 14.207Z"
          fill="#494949"
        />
      </g>
      <defs>
        <clipPath id="clip0_6659_2304">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(1 0 0 -1 0 24.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ChevronDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_6659_2374)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.46515 10.793C8.65268 10.6055 8.90699 10.5002 9.17215 10.5002C9.43731 10.5002 9.69162 10.6055 9.87915 10.793L12.0001 12.914L14.1212 10.793C14.3087 10.6053 14.563 10.4998 14.8283 10.4998C15.0936 10.4997 15.348 10.6049 15.5356 10.7925C15.7233 10.98 15.8288 11.2343 15.8289 11.4996C15.8289 11.7649 15.7237 12.0193 15.5361 12.207L12.7071 15.036C12.5196 15.2234 12.2653 15.3287 12.0001 15.3287C11.735 15.3287 11.4807 15.2234 11.2931 15.036L8.46515 12.207C8.27768 12.0194 8.17236 11.7651 8.17236 11.5C8.17236 11.2348 8.27768 10.9805 8.46515 10.793Z"
          fill="#494949"
        />
      </g>
      <defs>
        <clipPath id="clip0_6659_2374">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const EditStat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="rgb(var(--color-brand-strong))"
      className="group-hover:fill-white transition-colors duration-200"
    >
      <g clipPath="url(#clip0_7084_2111)">
        <path d="M13.5 3.5C13.7549 3.50028 14 3.59788 14.1854 3.77285C14.3707 3.94782 14.4822 4.18695 14.4972 4.44139C14.5121 4.69584 14.4293 4.94638 14.2657 5.14183C14.1021 5.33729 13.8701 5.4629 13.617 5.493L13.5 5.5H5.5V19.5H19.5V11.5C19.5003 11.2451 19.5979 11 19.7728 10.8146C19.9478 10.6293 20.187 10.5178 20.4414 10.5028C20.6958 10.4879 20.9464 10.5707 21.1418 10.7343C21.3373 10.8979 21.4629 11.1299 21.493 11.383L21.5 11.5V19.5C21.5002 20.0046 21.3096 20.4906 20.9665 20.8605C20.6234 21.2305 20.1532 21.4572 19.65 21.495L19.5 21.5H5.5C4.99542 21.5002 4.50943 21.3096 4.13945 20.9665C3.76947 20.6234 3.54284 20.1532 3.505 19.65L3.5 19.5V5.5C3.49984 4.99542 3.69041 4.50943 4.0335 4.13945C4.37659 3.76947 4.84684 3.54284 5.35 3.505L5.5 3.5H13.5ZM19.743 3.843C19.923 3.66365 20.1644 3.55953 20.4184 3.55177C20.6723 3.54402 20.9197 3.63322 21.1103 3.80125C21.3008 3.96928 21.4203 4.20355 21.4444 4.45647C21.4685 4.7094 21.3954 4.96201 21.24 5.163L21.157 5.258L11.257 15.157C11.077 15.3363 10.8356 15.4405 10.5816 15.4482C10.3277 15.456 10.0803 15.3668 9.88972 15.1988C9.69916 15.0307 9.57969 14.7964 9.5556 14.5435C9.53151 14.2906 9.60459 14.038 9.76 13.837L9.843 13.743L19.743 3.843Z" />
      </g>
      <defs>
        <clipPath id="clip0_7084_2111">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Trash = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_7010_21112)">
        <path
          d="M14.28 2.8728C14.6998 2.87291 15.1088 3.00509 15.4493 3.25061C15.7898 3.49613 16.0444 3.84255 16.177 4.2408L16.72 5.8728H20C20.2652 5.8728 20.5196 5.97816 20.7071 6.1657C20.8946 6.35323 21 6.60759 21 6.8728C21 7.13802 20.8946 7.39237 20.7071 7.57991C20.5196 7.76745 20.2652 7.8728 20 7.8728L19.997 7.9438L19.13 20.0868C19.0759 20.8434 18.7372 21.5514 18.182 22.0684C17.6269 22.5853 16.8965 22.8727 16.138 22.8728H7.862C7.10346 22.8727 6.37311 22.5853 5.81797 22.0684C5.26283 21.5514 4.92411 20.8434 4.87 20.0868L4.003 7.9428C4.00119 7.91951 4.00019 7.89616 4 7.8728C3.73478 7.8728 3.48043 7.76745 3.29289 7.57991C3.10536 7.39237 3 7.13802 3 6.8728C3 6.60759 3.10536 6.35323 3.29289 6.1657C3.48043 5.97816 3.73478 5.8728 4 5.8728H7.28L7.823 4.2408C7.9557 3.84239 8.21043 3.49585 8.5511 3.25032C8.89176 3.00478 9.30107 2.8727 9.721 2.8728H14.28ZM17.997 7.8728H6.003L6.865 19.9438C6.88295 20.196 6.99577 20.4321 7.18076 20.6044C7.36574 20.7768 7.60916 20.8727 7.862 20.8728H16.138C16.3908 20.8727 16.6343 20.7768 16.8192 20.6044C17.0042 20.4321 17.117 20.196 17.135 19.9438L17.997 7.8728ZM10 10.8728C10.2449 10.8728 10.4813 10.9628 10.6644 11.1255C10.8474 11.2883 10.9643 11.5126 10.993 11.7558L11 11.8728V16.8728C10.9997 17.1277 10.9021 17.3728 10.7272 17.5582C10.5522 17.7435 10.313 17.855 10.0586 17.87C9.80416 17.8849 9.55362 17.8021 9.35817 17.6385C9.16271 17.4749 9.0371 17.2429 9.007 16.9898L9 16.8728V11.8728C9 11.6076 9.10536 11.3532 9.29289 11.1657C9.48043 10.9782 9.73478 10.8728 10 10.8728ZM14 10.8728C14.2652 10.8728 14.5196 10.9782 14.7071 11.1657C14.8946 11.3532 15 11.6076 15 11.8728V16.8728C15 17.138 14.8946 17.3924 14.7071 17.5799C14.5196 17.7674 14.2652 17.8728 14 17.8728C13.7348 17.8728 13.4804 17.7674 13.2929 17.5799C13.1054 17.3924 13 17.138 13 16.8728V11.8728C13 11.6076 13.1054 11.3532 13.2929 11.1657C13.4804 10.9782 13.7348 10.8728 14 10.8728ZM14.28 4.8728H9.72L9.387 5.8728H14.613L14.28 4.8728Z"
          fill="#F4161A"
        />
      </g>
      <defs>
        <clipPath id="clip0_7010_21112">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.872803)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const WhiteMenueArrow = ({ isOpen }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      className={`${isOpen ? "rotate-180" : ""} duration-200 shrink-0`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.78888 0.878652C0.976408 0.691181 1.23072 0.585865 1.49588 0.585865C1.76104 0.585865 2.01535 0.691181 2.20288 0.878652L4.32388 2.99965L6.44488 0.878652C6.63239 0.691011 6.88675 0.585543 7.15203 0.585449C7.4173 0.585356 7.67174 0.690643 7.85938 0.878151C8.04702 1.06566 8.15249 1.32003 8.15258 1.5853C8.15268 1.85057 8.04739 2.10501 7.85988 2.29265L5.03088 5.12165C4.84335 5.30912 4.58904 5.41444 4.32388 5.41444C4.05872 5.41444 3.80441 5.30912 3.61688 5.12165L0.78888 2.29265C0.601409 2.10512 0.496094 1.85082 0.496094 1.58565C0.496094 1.32049 0.601409 1.06618 0.78888 0.878652Z"
        fill="white"
      />
    </svg>
  );
};
export const BlackMenueArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
      className={DIRECTION === "ltr" ? "rotate-180" : ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.34662 1.19676C4.49527 1.34545 4.57877 1.54709 4.57877 1.75735C4.57877 1.9676 4.49527 2.16925 4.34662 2.31794L2.66484 3.99972L4.34662 5.6815C4.4954 5.83017 4.57903 6.03187 4.5791 6.2422C4.57918 6.45254 4.49569 6.65429 4.34701 6.80308C4.19833 6.95186 3.99664 7.03549 3.7863 7.03556C3.57597 7.03564 3.37421 6.95215 3.22543 6.80347L0.982268 4.56031C0.833619 4.41162 0.750112 4.20997 0.750112 3.99972C0.750112 3.78946 0.833619 3.58782 0.982268 3.43913L3.22543 1.19676C3.37413 1.04811 3.57577 0.9646 3.78602 0.9646C3.99628 0.9646 4.19792 1.04811 4.34662 1.19676Z"
        fill="#0F1231"
      />
    </svg>
  );
};
export const DownArr = ({ isLngSelectOpen }) => {
  return (
    <svg
      className={`w-4 h-4 text-text-subtle transition-transform duration-200 ${isLngSelectOpen ? "rotate-180" : ""}`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  );
};
export const RightIcon = () => {
  return (
    <svg
      className="w-4 h-4 text-success ms-auto"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const PrIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.5 7.50032L10 1.66699L17.5 7.50032V16.667C17.5 17.109 17.3244 17.5329 17.0118 17.8455C16.6993 18.1581 16.2754 18.3337 15.8333 18.3337H4.16667C3.72464 18.3337 3.30072 18.1581 2.98816 17.8455C2.67559 17.5329 2.5 17.109 2.5 16.667V7.50032Z"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 18.3333V10H12.5V18.3333"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ConIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.6673 1.66699H5.00065C4.55862 1.66699 4.1347 1.84259 3.82214 2.15515C3.50958 2.46771 3.33398 2.89163 3.33398 3.33366V16.667C3.33398 17.109 3.50958 17.5329 3.82214 17.8455C4.1347 18.1581 4.55862 18.3337 5.00065 18.3337H15.0007C15.4427 18.3337 15.8666 18.1581 16.1792 17.8455C16.4917 17.5329 16.6673 17.109 16.6673 16.667V6.66699L11.6673 1.66699Z"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.666 1.66699V6.66699H16.666"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3327 10.833H6.66602"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3327 14.167H6.66602"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33366 7.5H7.50033H6.66699"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const MainDataIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15 8.33301H5"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 5H2.5"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 11.667H2.5"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 15H5"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SaleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5 1.66699L2.5 5.00033V16.667C2.5 17.109 2.67559 17.5329 2.98816 17.8455C3.30072 18.1581 3.72464 18.3337 4.16667 18.3337H15.8333C16.2754 18.3337 16.6993 18.1581 17.0118 17.8455C17.3244 17.5329 17.5 17.109 17.5 16.667V5.00033L15 1.66699H5Z"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5H17.5"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 8.33301C13.3337 9.21706 12.9825 10.0649 12.3573 10.69C11.7322 11.3152 10.8844 11.6663 10.0003 11.6663C9.11627 11.6663 8.26842 11.3152 7.6433 10.69C7.01818 10.0649 6.66699 9.21706 6.66699 8.33301"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LedgerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.33398 16.2503C3.33398 15.6978 3.55348 15.1679 3.94418 14.7772C4.33488 14.3865 4.86478 14.167 5.41732 14.167H16.6673"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41732 1.66699H16.6673V18.3337H5.41732C4.86478 18.3337 4.33488 18.1142 3.94418 17.7235C3.55348 17.3328 3.33398 16.8029 3.33398 16.2503V3.75033C3.33398 3.19779 3.55348 2.66789 3.94418 2.27719C4.33488 1.88649 4.86478 1.66699 5.41732 1.66699Z"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BuyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_9469_40444)">
        <path
          d="M7.49935 18.3337C7.95959 18.3337 8.33268 17.9606 8.33268 17.5003C8.33268 17.0401 7.95959 16.667 7.49935 16.667C7.03911 16.667 6.66602 17.0401 6.66602 17.5003C6.66602 17.9606 7.03911 18.3337 7.49935 18.3337Z"
          stroke={"#455560"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6673 18.3337C17.1276 18.3337 17.5007 17.9606 17.5007 17.5003C17.5007 17.0401 17.1276 16.667 16.6673 16.667C16.2071 16.667 15.834 17.0401 15.834 17.5003C15.834 17.9606 16.2071 18.3337 16.6673 18.3337Z"
          stroke={"#455560"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.833984 0.833008H4.16732L6.40065 11.9913C6.47685 12.375 6.68557 12.7196 6.99027 12.9649C7.29497 13.2102 7.67623 13.3405 8.06732 13.333H16.1673C16.5584 13.3405 16.9397 13.2102 17.2444 12.9649C17.5491 12.7196 17.7578 12.375 17.834 11.9913L19.1673 4.99967H5.00065"
          stroke={"#455560"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9469_40444">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const VouchersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.8337 13.3331H5.83367C5.61265 13.3331 5.40069 13.4209 5.24441 13.5771C5.08813 13.7334 5.00033 13.9454 5.00033 14.1664C5.00033 14.3874 5.08813 14.5994 5.24441 14.7557C5.40069 14.9119 5.61265 14.9997 5.83367 14.9997H10.8337C11.0547 14.9997 11.2666 14.9119 11.4229 14.7557C11.5792 14.5994 11.667 14.3874 11.667 14.1664C11.667 13.9454 11.5792 13.7334 11.4229 13.5771C11.2666 13.4209 11.0547 13.3331 10.8337 13.3331ZM7.50033 8.33307H9.167C9.38801 8.33307 9.59997 8.24527 9.75625 8.08899C9.91253 7.93271 10.0003 7.72075 10.0003 7.49973C10.0003 7.27872 9.91253 7.06676 9.75625 6.91048C9.59997 6.7542 9.38801 6.6664 9.167 6.6664H7.50033C7.27932 6.6664 7.06736 6.7542 6.91108 6.91048C6.7548 7.06676 6.667 7.27872 6.667 7.49973C6.667 7.72075 6.7548 7.93271 6.91108 8.08899C7.06736 8.24527 7.27932 8.33307 7.50033 8.33307ZM17.5003 9.99973H15.0003V2.49973C15.0009 2.35289 14.9627 2.2085 14.8895 2.08119C14.8163 1.95387 14.7108 1.84815 14.5837 1.77473C14.457 1.70159 14.3133 1.66309 14.167 1.66309C14.0207 1.66309 13.877 1.70159 13.7503 1.77473L11.2503 3.20806L8.75033 1.77473C8.62365 1.70159 8.47995 1.66309 8.33367 1.66309C8.18739 1.66309 8.04368 1.70159 7.917 1.77473L5.417 3.20806L2.917 1.77473C2.79032 1.70159 2.64661 1.66309 2.50033 1.66309C2.35405 1.66309 2.21035 1.70159 2.08367 1.77473C1.9565 1.84815 1.85098 1.95387 1.77781 2.08119C1.70464 2.2085 1.66642 2.35289 1.667 2.49973V15.8331C1.667 16.4961 1.93039 17.132 2.39923 17.6008C2.86807 18.0697 3.50396 18.3331 4.167 18.3331H15.8337C16.4967 18.3331 17.1326 18.0697 17.6014 17.6008C18.0703 17.132 18.3337 16.4961 18.3337 15.8331V10.8331C18.3337 10.6121 18.2459 10.4001 18.0896 10.2438C17.9333 10.0875 17.7213 9.99973 17.5003 9.99973ZM4.167 16.6664C3.94599 16.6664 3.73402 16.5786 3.57774 16.4223C3.42146 16.266 3.33367 16.0541 3.33367 15.8331V3.9414L5.00033 4.8914C5.12895 4.95857 5.2719 4.99366 5.417 4.99366C5.5621 4.99366 5.70505 4.95857 5.83367 4.8914L8.33367 3.45806L10.8337 4.8914C10.9623 4.95857 11.1052 4.99366 11.2503 4.99366C11.3954 4.99366 11.5384 4.95857 11.667 4.8914L13.3337 3.9414V15.8331C13.3359 16.1174 13.3866 16.3992 13.4837 16.6664H4.167ZM16.667 15.8331C16.667 16.0541 16.5792 16.266 16.4229 16.4223C16.2666 16.5786 16.0547 16.6664 15.8337 16.6664C15.6127 16.6664 15.4007 16.5786 15.2444 16.4223C15.0881 16.266 15.0003 16.0541 15.0003 15.8331V11.6664H16.667V15.8331ZM10.8337 9.99973H5.83367C5.61265 9.99973 5.40069 10.0875 5.24441 10.2438C5.08813 10.4001 5.00033 10.6121 5.00033 10.8331C5.00033 11.0541 5.08813 11.266 5.24441 11.4223C5.40069 11.5786 5.61265 11.6664 5.83367 11.6664H10.8337C11.0547 11.6664 11.2666 11.5786 11.4229 11.4223C11.5792 11.266 11.667 11.0541 11.667 10.8331C11.667 10.6121 11.5792 10.4001 11.4229 10.2438C11.2666 10.0875 11.0547 9.99973 10.8337 9.99973Z"
        fill={"#455560"}
      />
    </svg>
  );
};
export const ReportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_9469_40466)">
        <path
          d="M17.6747 13.2417C17.1445 14.4955 16.3153 15.6002 15.2596 16.4595C14.2038 17.3187 12.9537 17.9063 11.6184 18.1707C10.2831 18.4352 8.90337 18.3685 7.59981 17.9766C6.29624 17.5846 5.10854 16.8793 4.14053 15.9223C3.17253 14.9653 2.4537 13.7857 2.04688 12.4867C1.64006 11.1877 1.55765 9.8088 1.80685 8.47059C2.05605 7.13238 2.62926 5.87559 3.47639 4.81009C4.32351 3.74459 5.41875 2.90283 6.66635 2.3584"
          stroke={"#455560"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3333 10.0003C18.3333 8.90598 18.1178 7.82234 17.699 6.8113C17.2802 5.80025 16.6664 4.88159 15.8926 4.10777C15.1187 3.33395 14.2001 2.72012 13.189 2.30133C12.178 1.88254 11.0943 1.66699 10 1.66699V10.0003H18.3333Z"
          stroke={"#455560"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9469_40466">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ProductsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.83367 5.00034C5.66885 5.00034 5.50774 5.04921 5.3707 5.14078C5.23366 5.23235 5.12685 5.3625 5.06377 5.51477C5.0007 5.66704 4.9842 5.8346 5.01635 5.99625C5.04851 6.1579 5.12787 6.30638 5.24442 6.42293C5.36096 6.53947 5.50945 6.61884 5.6711 6.65099C5.83275 6.68315 6.0003 6.66665 6.15258 6.60357C6.30485 6.5405 6.435 6.43369 6.52656 6.29665C6.61813 6.15961 6.66701 5.99849 6.66701 5.83367C6.66701 5.61266 6.57921 5.4007 6.42293 5.24442C6.26665 5.08814 6.05469 5.00034 5.83367 5.00034ZM18.092 9.81701L10.192 1.93367C10.1143 1.84989 10.0202 1.78299 9.91556 1.73711C9.8109 1.69124 9.69794 1.66737 9.58367 1.66701H4.58367C4.474 1.66637 4.36528 1.68739 4.26375 1.72886C4.16222 1.77033 4.06987 1.83144 3.99201 1.90867L1.90867 3.98367C1.83144 4.06154 1.77033 4.15389 1.72886 4.25542C1.68739 4.35695 1.66637 4.46567 1.66701 4.57534V9.57534C1.67008 9.79598 1.75639 10.0073 1.90867 10.167L9.81701 18.0837C9.9767 18.236 10.188 18.3223 10.4087 18.3253C10.5183 18.326 10.6271 18.305 10.7286 18.2635C10.8301 18.222 10.9225 18.1609 11.0003 18.0837L18.092 10.992C18.1692 10.9141 18.2303 10.8218 18.2718 10.7203C18.3133 10.6187 18.3343 10.51 18.3337 10.4003C18.3285 10.1826 18.2424 9.9746 18.092 9.81701ZM10.4087 16.3253L3.33367 9.24201V4.91701L4.91701 3.33367H9.23367L16.317 10.4087L10.4087 16.3253Z"
        fill={"#455560"}
      />
    </svg>
  );
};
export const InventoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.75 7.83379L6.25 3.50879"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 13.3329V6.66626C17.4997 6.37399 17.4225 6.08693 17.2763 5.8339C17.13 5.58086 16.9198 5.37073 16.6667 5.22459L10.8333 1.89126C10.58 1.74498 10.2926 1.66797 10 1.66797C9.70744 1.66797 9.42003 1.74498 9.16667 1.89126L3.33333 5.22459C3.08022 5.37073 2.86998 5.58086 2.72372 5.8339C2.57745 6.08693 2.5003 6.37399 2.5 6.66626V13.3329C2.5003 13.6252 2.57745 13.9123 2.72372 14.1653C2.86998 14.4183 3.08022 14.6285 3.33333 14.7746L9.16667 18.1079C9.42003 18.2542 9.70744 18.3312 10 18.3312C10.2926 18.3312 10.58 18.2542 10.8333 18.1079L16.6667 14.7746C16.9198 14.6285 17.13 14.4183 17.2763 14.1653C17.4225 13.9123 17.4997 13.6252 17.5 13.3329Z"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.72461 5.7998L9.99961 10.0081L17.2746 5.7998"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.4V10"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PermissionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.334 3.33301H15.0007C15.4427 3.33301 15.8666 3.5086 16.1792 3.82116C16.4917 4.13372 16.6673 4.55765 16.6673 4.99967V16.6663C16.6673 17.1084 16.4917 17.5323 16.1792 17.8449C15.8666 18.1574 15.4427 18.333 15.0007 18.333H5.00065C4.55862 18.333 4.1347 18.1574 3.82214 17.8449C3.50958 17.5323 3.33398 17.1084 3.33398 16.6663V4.99967C3.33398 4.55765 3.50958 4.13372 3.82214 3.82116C4.1347 3.5086 4.55862 3.33301 5.00065 3.33301H6.66732"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4993 1.66699H7.49935C7.03911 1.66699 6.66602 2.04009 6.66602 2.50033V4.16699C6.66602 4.62723 7.03911 5.00033 7.49935 5.00033H12.4993C12.9596 5.00033 13.3327 4.62723 13.3327 4.16699V2.50033C13.3327 2.04009 12.9596 1.66699 12.4993 1.66699Z"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const WithdrawalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.834 1.66699H5.00065C4.55862 1.66699 4.1347 1.84259 3.82214 2.15515C3.50958 2.46771 3.33398 2.89163 3.33398 3.33366V16.667C3.33398 17.109 3.50958 17.5329 3.82214 17.8455C4.1347 18.1581 4.55862 18.3337 5.00065 18.3337H15.0007C15.4427 18.3337 15.8666 18.1581 16.1792 17.8455C16.4917 17.5329 16.6673 17.109 16.6673 16.667V7.50033L10.834 1.66699Z"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.834 1.66699V7.50032H16.6673"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EmployeeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6663 17.5V15.8333C16.6663 14.9493 16.3152 14.1014 15.69 13.4763C15.0649 12.8512 14.2171 12.5 13.333 12.5H6.66634C5.78229 12.5 4.93444 12.8512 4.30932 13.4763C3.6842 14.1014 3.33301 14.9493 3.33301 15.8333V17.5"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 9.16667C11.8413 9.16667 13.3337 7.67428 13.3337 5.83333C13.3337 3.99238 11.8413 2.5 10.0003 2.5C8.15938 2.5 6.66699 3.99238 6.66699 5.83333C6.66699 7.67428 8.15938 9.16667 10.0003 9.16667Z"
        stroke={"#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DownArrow = ({ className, isDark }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="4"
      viewBox="0 0 7 4"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.232156 0.318423C0.38085 0.169774 0.582495 0.0862672 0.792748 0.0862672C1.003 0.0862672 1.20465 0.169774 1.35334 0.318423L3.03512 2.0002L4.7169 0.318423C4.86557 0.169639 5.06727 0.0860119 5.2776 0.0859375C5.48794 0.0858632 5.68969 0.169347 5.83848 0.318026C5.98726 0.466704 6.07089 0.668397 6.07096 0.878735C6.07104 1.08907 5.98755 1.29082 5.83887 1.43961L3.59571 3.68277C3.44702 3.83142 3.24537 3.91493 3.03512 3.91493C2.82486 3.91493 2.62322 3.83142 2.47453 3.68277L0.232156 1.43961C0.0835065 1.29091 0 1.08927 0 0.879015C0 0.668762 0.0835065 0.467117 0.232156 0.318423Z"
        fill={isDark ? "#fff" : "#455560"}
      />
    </svg>
  );
};

export const ArabicIcon = ({ active, hasError }) => {
  const bg = hasError
    ? "#FEE2E2"
    : active
      ? "rgb(var(--color-brand-tint))"
      : "rgb(var(--color-border-muted))";
  const textColor = active ? "rgb(var(--color-brand))" : "#525252";
  return (
    <div
      style={{ background: bg, gap: "1px" }}
      className="w-9 h-9 rounded-s-md flex flex-col items-center justify-center shrink-0"
    >
      <img src="/icons/translation.svg" alt="" className="w-[11px] h-[11px]" />
      <span
        style={{
          color: textColor,
          fontSize: "9px",
          fontWeight: "700",
          lineHeight: "1",
          display: "block",
        }}
      >
        ع
      </span>
    </div>
  );
};

export const EnglishIcon = ({ active, hasError }) => {
  const bg = hasError
    ? "#FEE2E2"
    : active
      ? "rgb(var(--color-brand-tint))"
      : "rgb(var(--color-border-muted))";
  const textColor = active ? "rgb(var(--color-brand))" : "#525252";
  return (
    <div
      style={{ background: bg, gap: "1px" }}
      className="w-9 h-9 rounded-e-md flex flex-col items-center justify-center shrink-0"
    >
      <img src="/icons/translation.svg" alt="" className="w-[11px] h-[11px]" />
      <span
        style={{
          color: textColor,
          fontSize: "9px",
          fontWeight: "700",
          lineHeight: "1",
          display: "block",
        }}
      >
        EN
      </span>
    </div>
  );
};
export const BackArrow = ({ isDark }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.42505 16.6L12.8584 11.1667C13.5 10.525 13.5 9.47499 12.8584 8.83333L7.42505 3.39999"
        stroke={isDark ? "#B4B4B4" : "rgb(var(--color-text-muted))"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Lock = ({ isDark }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke={isDark ? "#B4B4B4" : "rgb(var(--color-text-muted))"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
        stroke={isDark ? "#B4B4B4" : "rgb(var(--color-text-muted))"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AdminsIcon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6673 17.5V15.8333C16.6673 14.9493 16.3161 14.1014 15.691 13.4763C15.0659 12.8512 14.218 12.5 13.334 12.5H6.66732C5.78326 12.5 4.93542 12.8512 4.31029 13.4763C3.68517 14.1014 3.33398 14.9493 3.33398 15.8333V17.5"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0013 9.16667C11.8423 9.16667 13.3346 7.67428 13.3346 5.83333C13.3346 3.99238 11.8423 2.5 10.0013 2.5C8.16035 2.5 6.66797 3.99238 6.66797 5.83333C6.66797 7.67428 8.16035 9.16667 10.0013 9.16667Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RolesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.667 5.83203H3.33366C2.41318 5.83203 1.66699 6.57822 1.66699 7.4987V15.832C1.66699 16.7525 2.41318 17.4987 3.33366 17.4987H16.667C17.5875 17.4987 18.3337 16.7525 18.3337 15.832V7.4987C18.3337 6.57822 17.5875 5.83203 16.667 5.83203Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 17.5V4.16667C13.3337 3.72464 13.1581 3.30072 12.8455 2.98816C12.5329 2.67559 12.109 2.5 11.667 2.5H8.33366C7.89163 2.5 7.46771 2.67559 7.15515 2.98816C6.84259 3.30072 6.66699 3.72464 6.66699 4.16667V17.5"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const OppIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="relative top-0.5"
    >
      <path
        d="M15 17.5C16.3807 17.5 17.5 16.3807 17.5 15C17.5 13.6193 16.3807 12.5 15 12.5C13.6193 12.5 12.5 13.6193 12.5 15C12.5 16.3807 13.6193 17.5 15 17.5Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.5C6.38071 7.5 7.5 6.38071 7.5 5C7.5 3.61929 6.38071 2.5 5 2.5C3.61929 2.5 2.5 3.61929 2.5 5C2.5 6.38071 3.61929 7.5 5 7.5Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.833 5H13.333C13.775 5 14.199 5.17559 14.5115 5.48816C14.8241 5.80072 14.9997 6.22464 14.9997 6.66667V12.5"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.5V17.5"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="relative top-0.5"
    >
      <path
        d="M16.1998 10.8333C16.0165 10.8333 15.8248 10.775 15.6415 10.7333C15.2702 10.6515 14.9054 10.5429 14.5498 10.4083C14.1632 10.2677 13.7383 10.275 13.3568 10.4288C12.9752 10.5827 12.6641 10.8722 12.4832 11.2416L12.2998 11.6166C11.4882 11.1651 10.7423 10.6043 10.0832 9.94997C9.42881 9.29082 8.86803 8.54497 8.41651 7.7333L8.76651 7.49997C9.13598 7.31907 9.42549 7.00791 9.57934 6.62638C9.73318 6.24485 9.74048 5.8199 9.59984 5.4333C9.46753 5.07699 9.35895 4.7123 9.27484 4.34164C9.23317 4.1583 9.19984 3.96664 9.17484 3.77497C9.07364 3.18799 8.76619 2.65642 8.30786 2.276C7.84952 1.89559 7.27042 1.69131 6.67484 1.69997H4.17484C3.8157 1.6966 3.46005 1.77065 3.1321 1.91708C2.80415 2.06351 2.5116 2.27888 2.27437 2.54854C2.03713 2.81819 1.86079 3.1358 1.75733 3.47973C1.65387 3.82367 1.62574 4.18585 1.67484 4.54164C2.11879 8.03279 3.7132 11.2765 6.20622 13.7605C8.69924 16.2445 11.9488 17.8271 15.4415 18.2583H15.7582C16.3727 18.2592 16.966 18.0337 17.4248 17.625C17.6885 17.3892 17.8991 17.1001 18.0427 16.7769C18.1864 16.4537 18.2598 16.1037 18.2582 15.75V13.25C18.248 12.6711 18.0372 12.1138 17.6618 11.673C17.2864 11.2323 16.7697 10.9355 16.1998 10.8333ZM16.6165 15.8333C16.6164 15.9516 16.591 16.0686 16.5422 16.1763C16.4933 16.2841 16.4221 16.3802 16.3332 16.4583C16.2401 16.5387 16.1312 16.5988 16.0135 16.6346C15.8958 16.6705 15.772 16.6814 15.6498 16.6666C12.5289 16.2665 9.63004 14.8387 7.41044 12.6085C5.19084 10.3784 3.77685 7.47275 3.39151 4.34997C3.37824 4.2279 3.38987 4.10441 3.42567 3.98696C3.46148 3.86951 3.52073 3.76054 3.59984 3.66664C3.67793 3.57775 3.77406 3.50651 3.88182 3.45765C3.98959 3.4088 4.10652 3.38345 4.22484 3.3833H6.72484C6.91863 3.37899 7.10786 3.44237 7.25996 3.56253C7.41206 3.68269 7.51752 3.85211 7.55817 4.04164C7.59151 4.26942 7.63317 4.49442 7.68317 4.71664C7.77944 5.15593 7.90756 5.58762 8.06651 6.00831L6.89984 6.54997C6.80009 6.59574 6.71036 6.66076 6.6358 6.7413C6.56125 6.82184 6.50334 6.91632 6.4654 7.0193C6.42746 7.12228 6.41023 7.23175 6.41471 7.34141C6.41919 7.45107 6.44529 7.55876 6.49151 7.6583C7.69084 10.2273 9.75588 12.2923 12.3248 13.4916C12.5277 13.575 12.7553 13.575 12.9582 13.4916C13.0621 13.4545 13.1576 13.397 13.2392 13.3226C13.3207 13.2482 13.3866 13.1584 13.4332 13.0583L13.9498 11.8916C14.3806 12.0457 14.8203 12.1737 15.2665 12.275C15.4887 12.325 15.7137 12.3666 15.9415 12.4C16.131 12.4406 16.3005 12.5461 16.4206 12.6982C16.5408 12.8503 16.6042 13.0395 16.5998 13.2333L16.6165 15.8333ZM18.2165 2.2333C18.1319 2.02968 17.9701 1.86787 17.7665 1.7833C17.6663 1.7406 17.5587 1.71795 17.4498 1.71664H14.1165C13.8955 1.71664 13.6835 1.80444 13.5273 1.96072C13.371 2.117 13.2832 2.32896 13.2832 2.54997C13.2832 2.77099 13.371 2.98295 13.5273 3.13923C13.6835 3.29551 13.8955 3.3833 14.1165 3.3833H15.4332L12.6915 6.13331C12.5363 6.28944 12.4492 6.50065 12.4492 6.7208C12.4492 6.94096 12.5363 7.15217 12.6915 7.30831C12.8476 7.46351 13.0589 7.55063 13.279 7.55063C13.4992 7.55063 13.7104 7.46351 13.8665 7.30831L16.6165 4.56664V5.8833C16.6165 6.10432 16.7043 6.31628 16.8606 6.47256C17.0169 6.62884 17.2288 6.71664 17.4498 6.71664C17.6709 6.71664 17.8828 6.62884 18.0391 6.47256C18.1954 6.31628 18.2832 6.10432 18.2832 5.8833V2.54997C18.2819 2.44107 18.2592 2.33349 18.2165 2.2333Z"
        fill="#455560"
      />
    </svg>
  );
};
export const UnitMessagesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="relative top-1"
    >
      <path
        d="M9.99984 7.49996C9.83502 7.49996 9.6739 7.54883 9.53686 7.6404C9.39982 7.73197 9.29301 7.86212 9.22994 8.01439C9.16686 8.16666 9.15036 8.33422 9.18252 8.49587C9.21467 8.65752 9.29404 8.806 9.41058 8.92255C9.52713 9.03909 9.67561 9.11846 9.83726 9.15061C9.99891 9.18277 10.1665 9.16627 10.3187 9.10319C10.471 9.04012 10.6012 8.93331 10.6927 8.79627C10.7843 8.65923 10.8332 8.49811 10.8332 8.33329C10.8332 8.11228 10.7454 7.90032 10.5891 7.74404C10.4328 7.58776 10.2209 7.49996 9.99984 7.49996ZM15.8332 1.66663H4.1665C3.50346 1.66663 2.86758 1.93002 2.39874 2.39886C1.9299 2.8677 1.6665 3.50358 1.6665 4.16663V12.5C1.6665 13.163 1.9299 13.7989 2.39874 14.2677C2.86758 14.7366 3.50346 15 4.1665 15H13.8248L16.9082 18.0916C16.986 18.1689 17.0784 18.23 17.1799 18.2714C17.2814 18.3129 17.3902 18.3339 17.4998 18.3333C17.6092 18.3361 17.7176 18.3133 17.8165 18.2666C17.9687 18.2041 18.099 18.0979 18.1909 17.9615C18.2828 17.8251 18.3323 17.6645 18.3332 17.5V4.16663C18.3332 3.50358 18.0698 2.8677 17.6009 2.39886C17.1321 1.93002 16.4962 1.66663 15.8332 1.66663ZM16.6665 15.4916L14.7582 13.575C14.6803 13.4977 14.588 13.4366 14.4864 13.3951C14.3849 13.3537 14.2762 13.3327 14.1665 13.3333H4.1665C3.94549 13.3333 3.73353 13.2455 3.57725 13.0892C3.42097 12.9329 3.33317 12.721 3.33317 12.5V4.16663C3.33317 3.94561 3.42097 3.73365 3.57725 3.57737C3.73353 3.42109 3.94549 3.33329 4.1665 3.33329H15.8332C16.0542 3.33329 16.2661 3.42109 16.4224 3.57737C16.5787 3.73365 16.6665 3.94561 16.6665 4.16663V15.4916ZM6.6665 7.49996C6.50169 7.49996 6.34057 7.54883 6.20353 7.6404C6.06649 7.73197 5.95968 7.86212 5.8966 8.01439C5.83353 8.16666 5.81703 8.33422 5.84918 8.49587C5.88134 8.65752 5.9607 8.806 6.07725 8.92255C6.19379 9.03909 6.34228 9.11846 6.50393 9.15061C6.66558 9.18277 6.83314 9.16627 6.98541 9.10319C7.13768 9.04012 7.26783 8.93331 7.3594 8.79627C7.45096 8.65923 7.49984 8.49811 7.49984 8.33329C7.49984 8.11228 7.41204 7.90032 7.25576 7.74404C7.09948 7.58776 6.88752 7.49996 6.6665 7.49996ZM13.3332 7.49996C13.1684 7.49996 13.0072 7.54883 12.8702 7.6404C12.7332 7.73197 12.6263 7.86212 12.5633 8.01439C12.5002 8.16666 12.4837 8.33422 12.5158 8.49587C12.548 8.65752 12.6274 8.806 12.7439 8.92255C12.8605 9.03909 13.0089 9.11846 13.1706 9.15061C13.3322 9.18277 13.4998 9.16627 13.6521 9.10319C13.8043 9.04012 13.9345 8.93331 14.0261 8.79627C14.1176 8.65923 14.1665 8.49811 14.1665 8.33329C14.1665 8.11228 14.0787 7.90032 13.9224 7.74404C13.7661 7.58776 13.5542 7.49996 13.3332 7.49996Z"
        fill="#455560"
      />
    </svg>
  );
};
export const SupportCenterIcon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="relative top-[3px]"
    >
      <g clipPath="url(#clip0_127_18364)">
        <path
          d="M9.99984 18.3333C14.6022 18.3333 18.3332 14.6023 18.3332 9.99996C18.3332 5.39759 14.6022 1.66663 9.99984 1.66663C5.39746 1.66663 1.6665 5.39759 1.6665 9.99996C1.6665 14.6023 5.39746 18.3333 9.99984 18.3333Z"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9248 6.66663L16.7081 14.95"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.0752 6.66663H17.6419"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.1499 10L10.9332 1.71667"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.07484 13.3334L3.2915 5.05005"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9251 13.3334H2.3584"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8502 10L9.06689 18.2833"
          stroke="#455560"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_127_18364">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const RemindersIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1875 3.59375H13.9062V2.34375C13.9062 2.25781 13.8359 2.1875 13.75 2.1875H12.6562C12.5703 2.1875 12.5 2.25781 12.5 2.34375V3.59375H7.5V2.34375C7.5 2.25781 7.42969 2.1875 7.34375 2.1875H6.25C6.16406 2.1875 6.09375 2.25781 6.09375 2.34375V3.59375H2.8125C2.4668 3.59375 2.1875 3.87305 2.1875 4.21875V17.1875C2.1875 17.5332 2.4668 17.8125 2.8125 17.8125H17.1875C17.5332 17.8125 17.8125 17.5332 17.8125 17.1875V4.21875C17.8125 3.87305 17.5332 3.59375 17.1875 3.59375ZM16.4062 16.4062H3.59375V5H6.09375V5.9375C6.09375 6.02344 6.16406 6.09375 6.25 6.09375H7.34375C7.42969 6.09375 7.5 6.02344 7.5 5.9375V5H12.5V5.9375C12.5 6.02344 12.5703 6.09375 12.6562 6.09375H13.75C13.8359 6.09375 13.9062 6.02344 13.9062 5.9375V5H16.4062V16.4062ZM13.4375 8.20312H12.3594C12.2598 8.20312 12.1641 8.25195 12.1055 8.33203L9.1582 12.3906L7.89453 10.6523C7.83594 10.5723 7.74219 10.5234 7.64063 10.5234H6.5625C6.43555 10.5234 6.36133 10.668 6.43555 10.7715L8.9043 14.1699C8.93349 14.2099 8.9717 14.2424 9.01582 14.2648C9.05994 14.2872 9.10872 14.2989 9.1582 14.2989C9.20769 14.2989 9.25647 14.2872 9.30059 14.2648C9.34471 14.2424 9.38292 14.2099 9.41211 14.1699L13.5645 8.45312C13.6387 8.34766 13.5645 8.20312 13.4375 8.20312Z"
        fill="#455560"
      />
    </svg>
  );
};
export const FavouritesIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.39 14.2525L5.5775 17.1066C5.39681 17.2418 5.18206 17.3241 4.95725 17.3443C4.73244 17.3644 4.50647 17.3216 4.30462 17.2206C4.10278 17.1196 3.93303 16.9644 3.81437 16.7724C3.69572 16.5804 3.63284 16.3591 3.63281 16.1334V4.78342C3.63281 4.13852 3.88897 3.52002 4.34497 3.06395C4.80097 2.6079 5.41944 2.35164 6.06438 2.35156H14.1709C14.8158 2.35164 15.4343 2.6079 15.8903 3.06395C16.3463 3.52002 16.6025 4.13852 16.6025 4.78342V16.1331C16.6025 16.3588 16.5396 16.5801 16.4209 16.7721C16.3023 16.9641 16.1325 17.1193 15.9307 17.2203C15.7288 17.3213 15.5029 17.3641 15.2781 17.344C15.0533 17.3238 14.8385 17.2415 14.6578 17.1062L10.8475 14.2525C10.6372 14.095 10.3815 14.0099 10.1187 14.0099C9.856 14.0099 9.60031 14.095 9.39 14.2525Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DealsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4375 6.09375V5.15625C13.4375 5.07031 13.3672 5 13.2812 5H5.78125C5.69531 5 5.625 5.07031 5.625 5.15625V6.09375C5.625 6.17969 5.69531 6.25 5.78125 6.25H13.2812C13.3672 6.25 13.4375 6.17969 13.4375 6.09375ZM5.78125 7.8125C5.69531 7.8125 5.625 7.88281 5.625 7.96875V8.90625C5.625 8.99219 5.69531 9.0625 5.78125 9.0625H9.375C9.46094 9.0625 9.53125 8.99219 9.53125 8.90625V7.96875C9.53125 7.88281 9.46094 7.8125 9.375 7.8125H5.78125ZM13.125 10.0781C10.7949 10.0781 8.90625 11.9668 8.90625 14.2969C8.90625 16.627 10.7949 18.5156 13.125 18.5156C15.4551 18.5156 17.3438 16.627 17.3438 14.2969C17.3438 11.9668 15.4551 10.0781 13.125 10.0781ZM15.2246 16.3965C14.6641 16.957 13.918 17.2656 13.125 17.2656C12.332 17.2656 11.5859 16.957 11.0254 16.3965C10.4648 15.8359 10.1562 15.0898 10.1562 14.2969C10.1562 13.5039 10.4648 12.7578 11.0254 12.1973C11.5859 11.6367 12.332 11.3281 13.125 11.3281C13.918 11.3281 14.6641 11.6367 15.2246 12.1973C15.7852 12.7578 16.0938 13.5039 16.0938 14.2969C16.0938 15.0898 15.7852 15.8359 15.2246 16.3965ZM14.8633 12.8125H13.998C13.9473 12.8125 13.9004 12.8359 13.8711 12.877L12.6309 14.5918L12.1797 13.9688C12.1652 13.9486 12.1462 13.9323 12.1241 13.921C12.102 13.9098 12.0775 13.9041 12.0527 13.9043H11.1914C11.0645 13.9043 10.9902 14.0488 11.0645 14.1523L12.5059 16.1465C12.5684 16.2324 12.6953 16.2324 12.7578 16.1465L14.9883 13.0605C15.0645 12.957 14.9902 12.8125 14.8633 12.8125ZM8.59375 16.6406H4.0625V2.89062H15V9.60938C15 9.69531 15.0703 9.76562 15.1562 9.76562H16.25C16.3359 9.76562 16.4062 9.69531 16.4062 9.60938V2.10938C16.4062 1.76367 16.127 1.48438 15.7812 1.48438H3.28125C2.93555 1.48438 2.65625 1.76367 2.65625 2.10938V17.4219C2.65625 17.7676 2.93555 18.0469 3.28125 18.0469H8.59375C8.67969 18.0469 8.75 17.9766 8.75 17.8906V16.7969C8.75 16.7109 8.67969 16.6406 8.59375 16.6406Z"
        fill="#455560"
      />
    </svg>
  );
};
export const InteractionsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4692 5.33203H9.52973C9.44379 5.33203 9.37348 5.40235 9.37348 5.48828V10.8652C9.37348 10.916 9.39692 10.9629 9.43793 10.9922L12.6664 13.3496C12.7368 13.4004 12.8344 13.3867 12.8852 13.3164L13.4438 12.5547C13.4965 12.4824 13.4809 12.3848 13.4106 12.3359L10.6254 10.3223V5.48828C10.6254 5.40235 10.5551 5.33203 10.4692 5.33203ZM14.7622 6.80078L17.8247 7.54883C17.9223 7.57227 18.018 7.49805 18.018 7.39844L18.0336 4.24414C18.0336 4.11328 17.8832 4.03907 17.7817 4.1211L14.7036 6.52539C14.6803 6.54339 14.6626 6.56759 14.6525 6.5952C14.6423 6.62282 14.6402 6.65273 14.6463 6.6815C14.6525 6.71027 14.6666 6.73672 14.6871 6.75782C14.7075 6.77893 14.7336 6.79382 14.7622 6.80078V6.80078ZM18.0375 12.6816L16.9301 12.3008C16.8915 12.2875 16.8493 12.2899 16.8124 12.3075C16.7755 12.325 16.747 12.3562 16.7329 12.3945C16.6957 12.4941 16.6567 12.5918 16.6157 12.6895C16.268 13.5117 15.77 14.252 15.1332 14.8867C14.5036 15.5183 13.7574 16.0218 12.936 16.3691C12.0851 16.7289 11.1704 16.9136 10.2465 16.9121C9.31293 16.9121 8.40864 16.7305 7.55707 16.3691C6.73567 16.0218 5.98946 15.5183 5.35981 14.8867C4.72504 14.252 4.227 13.5117 3.87739 12.6895C3.51961 11.8381 3.3363 10.9235 3.33832 10C3.33832 9.06641 3.51996 8.16016 3.88129 7.3086C4.22895 6.48633 4.727 5.7461 5.36372 5.11133C5.99336 4.47973 6.73957 3.97629 7.56098 3.62891C8.40864 3.26758 9.31489 3.08594 10.2485 3.08594C11.1821 3.08594 12.0864 3.26758 12.9379 3.62891C13.7593 3.97629 14.5055 4.47973 15.1352 5.11133C15.3344 5.3125 15.5219 5.52149 15.6938 5.74219L16.8618 4.82813C15.3247 2.86328 12.9321 1.59961 10.2446 1.60156C5.56489 1.60352 1.80707 5.4043 1.85395 10.0859C1.90082 14.6856 5.64106 18.3984 10.2485 18.3984C13.8715 18.3984 16.9575 16.1016 18.1332 12.8848C18.1625 12.8027 18.1196 12.7109 18.0375 12.6816V12.6816Z"
        fill="#455560"
      />
    </svg>
  );
};
export const ContactMessagesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="relative top-0.5"
    >
      <path
        d="M18.3334 8.33329V10.8333C18.3334 14.1666 16.6667 15.8333 13.3334 15.8333H12.9167C12.6584 15.8333 12.4084 15.9583 12.2501 16.1666L11.0001 17.8333C10.4501 18.5666 9.55008 18.5666 9.00008 17.8333L7.75008 16.1666C7.61675 15.9833 7.30841 15.8333 7.08341 15.8333H6.66675C3.33341 15.8333 1.66675 15 1.66675 10.8333V6.66663C1.66675 3.33329 3.33341 1.66663 6.66675 1.66663H11.6667"
        stroke="#455560"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2501 5.83329C17.4007 5.83329 18.3334 4.90055 18.3334 3.74996C18.3334 2.59937 17.4007 1.66663 16.2501 1.66663C15.0995 1.66663 14.1667 2.59937 14.1667 3.74996C14.1667 4.90055 15.0995 5.83329 16.2501 5.83329Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3303 9.16667H13.3378"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99632 9.16667H10.0038"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66209 9.16667H6.66957"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ToolsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="relative top-0.5"
    >
      <path
        d="M12.2511 5.25043C12.0984 5.4062 12.0129 5.61564 12.0129 5.83376C12.0129 6.05189 12.0984 6.26132 12.2511 6.4171L13.5844 7.75043C13.7402 7.90312 13.9496 7.98864 14.1678 7.98864C14.3859 7.98864 14.5953 7.90312 14.7511 7.75043L17.8928 4.60876C18.3118 5.53475 18.4387 6.56646 18.2565 7.56638C18.0743 8.56631 17.5917 9.48697 16.873 10.2057C16.1543 10.9244 15.2336 11.407 14.2337 11.5891C13.2338 11.7713 12.2021 11.6445 11.2761 11.2254L5.51777 16.9838C5.18625 17.3153 4.73661 17.5015 4.26777 17.5015C3.79893 17.5015 3.34929 17.3153 3.01777 16.9838C2.68625 16.6522 2.5 16.2026 2.5 15.7338C2.5 15.2649 2.68625 14.8153 3.01777 14.4838L8.7761 8.72543C8.35707 7.79944 8.2302 6.76774 8.41238 5.76781C8.59457 4.76788 9.07717 3.84723 9.79587 3.12853C10.5146 2.40984 11.4352 1.92724 12.4351 1.74505C13.4351 1.56286 14.4668 1.68973 15.3928 2.10876L12.2594 5.2421L12.2511 5.25043Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PosIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="relative top-px"
    >
      <path
        d="M2.5083 9.34998V13.0916C2.5083 16.8333 4.0083 18.3333 7.74997 18.3333H12.2416C15.9833 18.3333 17.4833 16.8333 17.4833 13.0916V9.34998"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99999 10C11.525 10 12.65 8.75835 12.5 7.23335L11.95 1.66669H8.05832L7.49999 7.23335C7.34999 8.75835 8.47499 10 9.99999 10Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2584 10C16.9417 10 18.1751 8.63335 18.0084 6.95835L17.7751 4.66669C17.4751 2.50002 16.6417 1.66669 14.4584 1.66669H11.9167L12.5001 7.50835C12.6417 8.88335 13.8834 10 15.2584 10Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6999 10C6.0749 10 7.31657 8.88335 7.4499 7.50835L7.63324 5.66669L8.03324 1.66669H5.49157C3.30824 1.66669 2.4749 2.50002 2.1749 4.66669L1.9499 6.95835C1.78324 8.63335 3.01657 10 4.6999 10Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0001 14.1667C8.60841 14.1667 7.91675 14.8584 7.91675 16.25V18.3334H12.0834V16.25C12.0834 14.8584 11.3917 14.1667 10.0001 14.1667Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PotentiolCustomerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="relative top-p"
    >
      <path
        d="M14.9999 5.96663C14.9499 5.9583 14.8916 5.9583 14.8416 5.96663C13.6916 5.92496 12.7749 4.98329 12.7749 3.81663C12.7749 2.62496 13.7332 1.66663 14.9249 1.66663C16.1166 1.66663 17.0749 2.63329 17.0749 3.81663C17.0666 4.98329 16.1499 5.92496 14.9999 5.96663Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1415 12.0333C15.2831 12.225 16.5415 12.025 17.4248 11.4333C18.5998 10.65 18.5998 9.36664 17.4248 8.58331C16.5331 7.99164 15.2581 7.79163 14.1165 7.99163"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.9749 5.96663C5.0249 5.9583 5.08324 5.9583 5.13324 5.96663C6.28324 5.92496 7.1999 4.98329 7.1999 3.81663C7.1999 2.62496 6.24157 1.66663 5.0499 1.66663C3.85824 1.66663 2.8999 2.63329 2.8999 3.81663C2.90824 4.98329 3.8249 5.92496 4.9749 5.96663Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83328 12.0333C4.69162 12.225 3.43328 12.025 2.54995 11.4333C1.37495 10.65 1.37495 9.36664 2.54995 8.58331C3.44162 7.99164 4.71662 7.79163 5.85828 7.99163"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0001 12.1917C9.95014 12.1834 9.89181 12.1834 9.84181 12.1917C8.69181 12.1501 7.77515 11.2084 7.77515 10.0417C7.77515 8.85006 8.73348 7.89172 9.92514 7.89172C11.1168 7.89172 12.0751 8.85839 12.0751 10.0417C12.0668 11.2084 11.1501 12.1584 10.0001 12.1917Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5751 14.8167C6.4001 15.6 6.4001 16.8833 7.5751 17.6667C8.90843 18.5583 11.0918 18.5583 12.4251 17.6667C13.6001 16.8833 13.6001 15.6 12.4251 14.8167C11.1001 13.9333 8.90843 13.9333 7.5751 14.8167Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BoxIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.6416 6.19995L9.99993 10.4583L17.3083 6.22495"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.0083V10.45"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.27503 2.0667L3.82503 4.53336C2.8167 5.0917 1.9917 6.4917 1.9917 7.6417V12.35C1.9917 13.5 2.8167 14.9 3.82503 15.4584L8.27503 17.9334C9.22503 18.4584 10.7834 18.4584 11.7334 17.9334L16.1834 15.4584C17.1917 14.9 18.0167 13.5 18.0167 12.35V7.6417C18.0167 6.4917 17.1917 5.0917 16.1834 4.53336L11.7334 2.05836C10.775 1.53336 9.22503 1.53336 8.27503 2.0667Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LoadingSpinner = () => (
  <svg
    className="animate-spin h-4 w-4 text-brand"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const DefaultPolicyIcon = () => {
  return (
    <div class="p-1 bg-brand-tint rounded-[50px] inline-flex justify-start items-center gap-2.5">
      <div class="w-3.5 h-3.5 flex justify-center items-center">
        <TickCircleIcon
          role="img"
          aria-hidden="false"
          aria-label="default policy"
          className="h-4 w-4 shrink-0"
        />
      </div>
    </div>
  );
};

export const NonDefaultPolicyIcon = () => {
  return (
    <div class="p-1 rounded-[50px] inline-flex justify-start items-center gap-2.5">
      <div class="w-3.5 h-3.5 flex justify-center items-center">
        <img src="/icons/tick-circle-2.svg" alt="default policy" />
      </div>
    </div>
  );
};

export const TasksIcon = ({ isDark }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 12L10.9293 13.9293C10.9683 13.9683 11.0317 13.9683 11.0707 13.9293L15 10M3 3.1V20.9C3 20.9552 3.04477 21 3.1 21H20.9C20.9552 21 21 20.9552 21 20.9V3.1C21 3.04477 20.9552 3 20.9 3H3.1C3.04477 3 3 3.04477 3 3.1Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

// Image gallery icons
export const ImageDeleteIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 5.2H4.55556M4.55556 5.2H17M4.55556 5.2V16.4C4.55556 16.8243 4.71944 17.2313 5.01117 17.5314C5.30289 17.8314 5.69855 18 6.11111 18H13.8889C14.3014 18 14.6971 17.8314 14.9888 17.5314C15.2806 17.2313 15.4444 16.8243 15.4444 16.4V5.2M6.88889 5.2V3.6C6.88889 3.17565 7.05278 2.76869 7.3445 2.46863C7.63622 2.16857 8.03189 2 8.44444 2H11.5556C11.9681 2 12.3638 2.16857 12.6555 2.46863C12.9472 2.76869 13.1111 3.17565 13.1111 3.6V5.2M8.44444 9.2V14M11.5556 9.2V14"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ImageViewIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9823 9.99993C12.9823 11.6499 11.649 12.9833 9.99896 12.9833C8.34896 12.9833 7.01562 11.6499 7.01562 9.99993C7.01562 8.34993 8.34896 7.0166 9.99896 7.0166C11.649 7.0166 12.9823 8.34993 12.9823 9.99993Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0018 16.8918C12.9435 16.8918 15.6852 15.1584 17.5935 12.1584C18.3435 10.9834 18.3435 9.00843 17.5935 7.83343C15.6852 4.83343 12.9435 3.1001 10.0018 3.1001C7.06016 3.1001 4.31849 4.83343 2.41016 7.83343C1.66016 9.00843 1.66016 10.9834 2.41016 12.1584C4.31849 15.1584 7.06016 16.8918 10.0018 16.8918Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddImageIcon = ({ width = 28, height = 28 }) => (
  <MaskIcon
    src="/icons/pic_2_fill.svg"
    className="bg-brand"
    style={{ width, height }}
  />
);

// Small calendar icon for dates
export const SmallCalendarIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 2H2.5C1.94772 2 1.5 2.44772 1.5 3V10C1.5 10.5523 1.94772 11 2.5 11H9.5C10.0523 11 10.5 10.5523 10.5 10V3C10.5 2.44772 10.0523 2 9.5 2Z"
      stroke="#B4B4B4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1V3"
      stroke="#B4B4B4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 1V3"
      stroke="#B4B4B4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 5H10.5"
      stroke="#B4B4B4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// File action icons for attachments
export const FileDeleteIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4.6H3.77778M3.77778 4.6H18M3.77778 4.6V17.2C3.77778 17.6774 3.96508 18.1352 4.29848 18.4728C4.63188 18.8104 5.08406 19 5.55556 19H14.4444C14.9159 19 15.3681 18.8104 15.7015 18.4728C16.0349 18.1352 16.2222 17.6774 16.2222 17.2V4.6M6.44444 4.6V2.8C6.44444 2.32261 6.63175 1.86477 6.96514 1.52721C7.29854 1.18964 7.75073 1 8.22222 1H11.7778C12.2493 1 12.7015 1.18964 13.0349 1.52721C13.3683 1.86477 13.5556 2.32261 13.5556 2.8V4.6M8.22222 9.1V14.5M11.7778 9.1V14.5"
      stroke="rgb(var(--color-danger))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileEditIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0514 3.00002L4.20976 10.2417C3.95142 10.5167 3.70142 11.0584 3.65142 11.4334L3.34309 14.1333C3.23476 15.1083 3.93476 15.775 4.90142 15.6084L7.58476 15.15C7.95976 15.0834 8.48476 14.8084 8.74309 14.525L15.5848 7.28335C16.7681 6.03335 17.3014 4.60835 15.4598 2.86668C13.6264 1.14168 12.2348 1.75002 11.0514 3.00002Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91016 4.20801C10.2685 6.50801 12.1352 8.26634 14.4518 8.49967"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 18.333H17.5"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileViewIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9823 9.99993C12.9823 11.6499 11.649 12.9833 9.99896 12.9833C8.34896 12.9833 7.01562 11.6499 7.01562 9.99993C7.01562 8.34993 8.34896 7.0166 9.99896 7.0166C11.649 7.0166 12.9823 8.34993 12.9823 9.99993Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0018 16.8913C12.9435 16.8913 15.6852 15.1579 17.5935 12.1579C18.3435 10.9829 18.3435 9.00794 17.5935 7.83294C15.6852 4.83294 12.9435 3.09961 10.0018 3.09961C7.06016 3.09961 4.31849 4.83294 2.41016 7.83294C1.66016 9.00794 1.66016 10.9829 2.41016 12.1579C4.31849 15.1579 7.06016 16.8913 10.0018 16.8913Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EntitiesSearchIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5462 9.51265C18.1497 9.51265 18.4016 8.69849 17.9114 8.32319L10.4524 2.62612C10.3459 2.54418 10.2173 2.5 10.0852 2.5C9.95319 2.5 9.82458 2.54418 9.71806 2.62612L2.25907 8.32319C1.76884 8.69644 2.02079 9.51265 2.62626 9.51265H3.83524V17.1826H2.42899C2.34306 17.1826 2.27274 17.2564 2.27274 17.3466V18.413C2.27274 18.5033 2.34306 18.5771 2.42899 18.5771H17.7415C17.8274 18.5771 17.8977 18.5033 17.8977 18.413V17.3466C17.8977 17.2564 17.8274 17.1826 17.7415 17.1826H16.3352V9.51265H17.5462ZM10.0852 4.07192L15.3802 8.11606H4.79032L10.0852 4.07192ZM5.24149 9.51265H7.52665V17.1826H5.24149V9.51265ZM8.9329 9.51265H11.2181V17.1826H8.9329V9.51265ZM14.929 17.1826H12.6243V9.51265H14.929V17.1826Z"
      fill="rgb(var(--color-brand))"
    />
  </svg>
);

export const InvoicesSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0833 6.60023V10.8919C16.0833 13.4586 14.6167 14.5586 12.4167 14.5586H5.09165C4.71665 14.5586 4.35832 14.5253 4.02498 14.4503C3.81665 14.4169 3.61666 14.3586 3.43332 14.2919C2.18332 13.8253 1.42499 12.7419 1.42499 10.8919V6.60023C1.42499 4.03356 2.89165 2.93359 5.09165 2.93359H12.4167C14.2833 2.93359 15.625 3.72526 15.9833 5.53359C16.0417 5.86692 16.0833 6.20856 16.0833 6.60023Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5842 9.10033V13.392C18.5842 15.9587 17.1176 17.0587 14.9176 17.0587H7.59256C6.97589 17.0587 6.41757 16.9754 5.93423 16.792C4.94257 16.4254 4.26756 15.667 4.02589 14.4504C4.35923 14.5254 4.71756 14.5587 5.09256 14.5587H12.4176C14.6176 14.5587 16.0842 13.4587 16.0842 10.892V6.60033C16.0842 6.20866 16.0509 5.85869 15.9842 5.53369C17.5676 5.86702 18.5842 6.98366 18.5842 9.10033Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.7487 10.9503C9.96373 10.9503 10.9487 9.96533 10.9487 8.75031C10.9487 7.53528 9.96373 6.55029 8.7487 6.55029C7.53368 6.55029 6.54869 7.53528 6.54869 8.75031C6.54869 9.96533 7.53368 10.9503 8.7487 10.9503Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.98332 6.91699V10.5837"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5181 6.91699V10.5837"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProjectsSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.58335 14.9998H3.45836C2.26669 14.9998 1.66667 14.3998 1.66667 13.2081V3.45819C1.66667 2.26652 2.26669 1.6665 3.45836 1.6665H7.04168C8.23335 1.6665 8.83332 2.26652 8.83332 3.45819V4.99984"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.475 7.01665V16.3167C14.475 17.6583 13.8084 18.3333 12.4667 18.3333H7.6C6.25833 18.3333 5.58334 17.6583 5.58334 16.3167V7.01665C5.58334 5.67499 6.25833 5 7.6 5H12.4667C13.8084 5 14.475 5.67499 14.475 7.01665Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1667 4.99984V3.45819C11.1667 2.26652 11.7667 1.6665 12.9583 1.6665H16.5416C17.7333 1.6665 18.3333 2.26652 18.3333 3.45819V13.2081C18.3333 14.3998 17.7333 14.9998 16.5416 14.9998H14.475"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33333 9.1665H11.6667"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33333 11.6665H11.6667"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 18.3335V15.8335"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VouchersSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8332 13.3336H5.83318C5.61216 13.3336 5.4002 13.4213 5.24392 13.5776C5.08764 13.7339 4.99984 13.9459 4.99984 14.1669C4.99984 14.3879 5.08764 14.5999 5.24392 14.7561C5.4002 14.9124 5.61216 15.0002 5.83318 15.0002H10.8332C11.0542 15.0002 11.2662 14.9124 11.4224 14.7561C11.5787 14.5999 11.6665 14.3879 11.6665 14.1669C11.6665 13.9459 11.5787 13.7339 11.4224 13.5776C11.2662 13.4213 11.0542 13.3336 10.8332 13.3336ZM7.49984 8.33355H9.16651C9.38752 8.33355 9.59949 8.24576 9.75577 8.08948C9.91205 7.93319 9.99984 7.72123 9.99984 7.50022C9.99984 7.27921 9.91205 7.06724 9.75577 6.91096C9.59949 6.75468 9.38752 6.66689 9.16651 6.66689H7.49984C7.27883 6.66689 7.06687 6.75468 6.91059 6.91096C6.75431 7.06724 6.66651 7.27921 6.66651 7.50022C6.66651 7.72123 6.75431 7.93319 6.91059 8.08948C7.06687 8.24576 7.27883 8.33355 7.49984 8.33355ZM17.4998 10.0002H14.9998V2.50022C15.0004 2.35338 14.9622 2.20899 14.889 2.08167C14.8159 1.95436 14.7103 1.84864 14.5832 1.77522C14.4565 1.70208 14.3128 1.66357 14.1665 1.66357C14.0202 1.66357 13.8765 1.70208 13.7498 1.77522L11.2498 3.20855L8.74984 1.77522C8.62316 1.70208 8.47946 1.66357 8.33318 1.66357C8.1869 1.66357 8.04319 1.70208 7.91651 1.77522L5.41651 3.20855L2.91651 1.77522C2.78983 1.70208 2.64612 1.66357 2.49984 1.66357C2.35356 1.66357 2.20986 1.70208 2.08318 1.77522C1.95601 1.84864 1.8505 1.95436 1.77733 2.08167C1.70416 2.20899 1.66593 2.35338 1.66651 2.50022V15.8336C1.66651 16.4966 1.9299 17.1325 2.39874 17.6013C2.86758 18.0702 3.50347 18.3336 4.16651 18.3336H15.8332C16.4962 18.3336 17.1321 18.0702 17.6009 17.6013C18.0698 17.1325 18.3332 16.4966 18.3332 15.8336V10.8336C18.3332 10.6125 18.2454 10.4006 18.0891 10.2443C17.9328 10.088 17.7209 10.0002 17.4998 10.0002ZM4.16651 16.6669C3.9455 16.6669 3.73354 16.5791 3.57726 16.4228C3.42097 16.2665 3.33318 16.0546 3.33318 15.8336V3.94189L4.99984 4.89189C5.12846 4.95906 5.27141 4.99415 5.41651 4.99415C5.56161 4.99415 5.70456 4.95906 5.83318 4.89189L8.33318 3.45855L10.8332 4.89189C10.9618 4.95906 11.1047 4.99415 11.2498 4.99415C11.3949 4.99415 11.5379 4.95906 11.6665 4.89189L13.3332 3.94189V15.8336C13.3354 16.1178 13.3862 16.3997 13.4832 16.6669H4.16651ZM16.6665 15.8336C16.6665 16.0546 16.5787 16.2665 16.4224 16.4228C16.2662 16.5791 16.0542 16.6669 15.8332 16.6669C15.6122 16.6669 15.4002 16.5791 15.2439 16.4228C15.0876 16.2665 14.9998 16.0546 14.9998 15.8336V11.6669H16.6665V15.8336ZM10.8332 10.0002H5.83318C5.61216 10.0002 5.4002 10.088 5.24392 10.2443C5.08764 10.4006 4.99984 10.6125 4.99984 10.8336C4.99984 11.0546 5.08764 11.2665 5.24392 11.4228C5.4002 11.5791 5.61216 11.6669 5.83318 11.6669H10.8332C11.0542 11.6669 11.2662 11.5791 11.4224 11.4228C11.5787 11.2665 11.6665 11.0546 11.6665 10.8336C11.6665 10.6125 11.5787 10.4006 11.4224 10.2443C11.2662 10.088 11.0542 10.0002 10.8332 10.0002Z"
      fill="rgb(var(--color-brand))"
    />
  </svg>
);

export const PropertiesSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1105_23724)">
      <path
        d="M10.8337 2.5C11.2542 2.49987 11.6592 2.65867 11.9675 2.94458C12.2758 3.23049 12.4647 3.62237 12.4962 4.04167L12.5004 4.16667V7.5H15.0004C15.4209 7.49987 15.8259 7.65867 16.1342 7.94458C16.4425 8.23049 16.6313 8.62237 16.6629 9.04167L16.667 9.16667V15.8333H17.5004C17.7128 15.8336 17.9171 15.9149 18.0715 16.0607C18.226 16.2065 18.3189 16.4058 18.3314 16.6178C18.3438 16.8299 18.2748 17.0386 18.1385 17.2015C18.0022 17.3644 17.8088 17.4691 17.5979 17.4942L17.5004 17.5H2.50038C2.28798 17.4998 2.08369 17.4184 1.92924 17.2726C1.77479 17.1268 1.68185 16.9275 1.6694 16.7155C1.65695 16.5035 1.72594 16.2947 1.86227 16.1318C1.99859 15.9689 2.19197 15.8643 2.40288 15.8392L2.50038 15.8333H3.33371V4.16667C3.33358 3.74619 3.49238 3.34119 3.77829 3.03288C4.0642 2.72456 4.45608 2.5357 4.87538 2.50417L5.00038 2.5H10.8337ZM15.0004 9.16667H12.5004V15.8333H15.0004V9.16667ZM10.8337 4.16667H5.00038V15.8333H10.8337V4.16667ZM9.16705 12.5V14.1667H6.66705V12.5H9.16705ZM9.16705 9.16667V10.8333H6.66705V9.16667H9.16705ZM9.16705 5.83333V7.5H6.66705V5.83333H9.16705Z"
        fill="rgb(var(--color-brand))"
      />
    </g>
    <defs>
      <clipPath id="clip0_1105_23724">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UnitsSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1105_23855)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.97708 2.23983C9.26965 2.01224 9.62974 1.88867 10.0004 1.88867C10.3711 1.88867 10.7312 2.01224 11.0237 2.23983L18.0104 7.67316C18.6379 8.16233 18.2912 9.1665 17.4979 9.1665H16.6671V15.8332C16.6671 16.2752 16.4915 16.6991 16.1789 17.0117C15.8664 17.3242 15.4424 17.4998 15.0004 17.4998H5.00041C4.55838 17.4998 4.13446 17.3242 3.8219 17.0117C3.50934 16.6991 3.33375 16.2752 3.33375 15.8332V9.1665H2.50291C1.70875 9.1665 1.36375 8.1615 1.99041 7.674L8.97708 2.23983ZM4.68791 7.68733C4.87875 7.8415 5.00041 8.07733 5.00041 8.3415V15.8332H15.0004V8.3415C15.0004 8.07733 15.1221 7.8415 15.3129 7.68733L10.0004 3.55566L4.68791 7.68733Z"
        fill="rgb(var(--color-brand))"
      />
    </g>
    <defs>
      <clipPath id="clip0_1105_23855">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CustomersSearchIcon = () => (
  <img src="/image.png" alt="customer" width="20" height="20" />
);

export const CurrencyIcon = ({ bgColor = "#525252" }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ stroke: bgColor }}
  >
    <path
      d="M6.78036 2.39304C7.16068 1.97885 7.39353 1.78477 7.83949 1.52051V7.43393L10.4761 6.89134C10.4471 7.15382 10.419 7.26528 10.368 7.45592C10.3169 7.64656 10.2686 7.8043 10.174 8.01684L6.78036 8.72439V2.39304Z"
      fill={bgColor}
      fillOpacity="0.7"
    />
    <path
      d="M5.73639 1C5.18818 1.31523 5.09495 1.4326 4.67833 1.85049V8.36519L1.82061 8.9701C1.66398 9.24139 1.50734 10.0773 1.51853 10.0919C1.52972 10.1066 4.53448 9.44669 4.62505 9.44669C4.8007 9.36606 4.91221 9.31838 5.03155 9.1754C5.15089 9.03242 5.30752 8.79413 5.30752 8.79413L5.60959 8.33953C5.70064 8.21127 5.73027 8.13388 5.73639 7.98392V1Z"
      fill="#525252"
      fillOpacity="0.7"
    />
    <path
      d="M2.32272 6.55742L10.482 4.83154C10.4018 5.33645 10.3313 5.58618 10.165 5.97592L2.02066 7.70179C2.07837 7.27077 2.12462 7.02567 2.32272 6.55742Z"
      fill="#525252"
      fillOpacity="0.7"
    />
    <path
      d="M7.08115 9.84054L10.478 9.13965C10.4131 9.61156 10.3483 9.86309 10.1722 10.2842L6.77167 11C6.84825 10.5514 6.91707 10.2996 7.08115 9.84054Z"
      fill="#525252"
      fillOpacity="0.7"
    />
  </svg>
);

export const MoreToolsIcon = ({ isDark }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cursor-pointer"
  >
    <mask
      id="mask0_more_tools"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path d="M24 0H0V24H24V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_more_tools)">
      <path
        d="M4.00122 3.99902H20.0012V17.999C20.0012 19.1035 19.1058 19.999 18.0012 19.999H6.00122C4.89665 19.999 4.00122 19.1035 4.00122 17.999V3.99902Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0115 12.0077V11.998H12.0018V12.0077H12.0115Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.5115 12.0077V11.998H16.5018V12.0077H16.5115Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M7.51147 12.0077V11.998H7.50182V12.0077H7.51147Z"
        stroke={isDark ? "white" : "#455560"}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const ProductsSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.6416 6.19995L9.99993 10.4583L17.3083 6.22495"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 18.0083V10.45"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.27503 2.0667L3.82503 4.53336C2.8167 5.0917 1.9917 6.4917 1.9917 7.6417V12.35C1.9917 13.5 2.8167 14.9 3.82503 15.4584L8.27503 17.9334C9.22503 18.4584 10.7834 18.4584 11.7334 17.9334L16.1834 15.4584C17.1917 14.9 18.0167 13.5 18.0167 12.35V7.6417C18.0167 6.4917 17.1917 5.0917 16.1834 4.53336L11.7334 2.05836C10.775 1.53336 9.22503 1.53336 8.27503 2.0667Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContractsSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6667 2.5H3.33333C2.41286 2.5 1.66667 3.24619 1.66667 4.16667V15.8333C1.66667 16.7538 2.41286 17.5 3.33333 17.5H16.6667C17.5871 17.5 18.3333 16.7538 18.3333 15.8333V4.16667C18.3333 3.24619 17.5871 2.5 16.6667 2.5Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 5.83333H13.3333"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 10H13.3333"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 14.1667H10"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeadContactsSearchIcon = () => (
  <img src="/image.png" alt="lead contact" width="20" height="20" />
);

export const SupportCenterSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 14.167V11.667C2.5 7.5 5.833 4.167 10 4.167s7.5 3.333 7.5 7.5v2.5"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 14.167h-2.5a1.667 1.667 0 0 1-1.667-1.667v-1.667a1.667 1.667 0 0 1 1.667-1.667h2.5"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 14.167h2.5a1.667 1.667 0 0 0 1.667-1.667v-1.667A1.667 1.667 0 0 0 5 9.167H2.5"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UnitMessagesSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 9.167c0 4.166-3.667 7.5-7.5 7.5-1.5 0-3-.333-4.167-1L2.5 17.5l.833-3.333C1.667 12.667 1.25 10.833 1.25 9.167 1.25 5 5 1.667 10 1.667s8.75 3.333 8.75 7.5z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MoreSearchIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5249 2.03996L4.2649 5.29996C3.8799 5.68496 3.8799 6.31496 4.2649 6.69996L7.5249 9.95996"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DiscardSearchIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.9999 5.20003L8.80003 2.3999L9.5999 3.19978L6.79978 5.9999L9.5999 8.80003L8.80003 9.5999L5.9999 6.79978L3.19978 9.5999L2.3999 8.80003L5.20003 5.9999L2.3999 3.19978L3.19978 2.3999L5.9999 5.20003Z"
      fill="#525252"
    />
  </svg>
);
export const PayoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_9469_40538)">
        <path
          d="M18.333 14.1663H1.66634C1.44533 14.1663 1.23337 14.2541 1.07709 14.4104C0.920805 14.5667 0.833008 14.7787 0.833008 14.9997C0.833008 15.2207 0.920805 15.4327 1.07709 15.5889C1.23337 15.7452 1.44533 15.833 1.66634 15.833H18.333C18.554 15.833 18.766 15.7452 18.9223 15.5889C19.0785 15.4327 19.1663 15.2207 19.1663 14.9997C19.1663 14.7787 19.0785 14.5667 18.9223 14.4104C18.766 14.2541 18.554 14.1663 18.333 14.1663ZM18.333 17.4997H1.66634C1.44533 17.4997 1.23337 17.5875 1.07709 17.7438C0.920805 17.9 0.833008 18.112 0.833008 18.333C0.833008 18.554 0.920805 18.766 1.07709 18.9223C1.23337 19.0785 1.44533 19.1663 1.66634 19.1663H18.333C18.554 19.1663 18.766 19.0785 18.9223 18.9223C19.0785 18.766 19.1663 18.554 19.1663 18.333C19.1663 18.112 19.0785 17.9 18.9223 17.7438C18.766 17.5875 18.554 17.4997 18.333 17.4997ZM4.99967 5.83301C4.83486 5.83301 4.67374 5.88188 4.5367 5.97345C4.39966 6.06502 4.29285 6.19517 4.22977 6.34744C4.1667 6.49971 4.1502 6.66727 4.18235 6.82892C4.21451 6.99057 4.29388 7.13905 4.41042 7.2556C4.52696 7.37214 4.67545 7.45151 4.8371 7.48366C4.99875 7.51582 5.16631 7.49931 5.31858 7.43624C5.47085 7.37317 5.601 7.26636 5.69257 7.12932C5.78413 6.99228 5.83301 6.83116 5.83301 6.66634C5.83301 6.44533 5.74521 6.23337 5.58893 6.07709C5.43265 5.92081 5.22069 5.83301 4.99967 5.83301ZM16.6663 0.833008H3.33301C2.66997 0.833008 2.03408 1.0964 1.56524 1.56524C1.0964 2.03408 0.833008 2.66997 0.833008 3.33301V9.99967C0.833008 10.6627 1.0964 11.2986 1.56524 11.7674C2.03408 12.2363 2.66997 12.4997 3.33301 12.4997H16.6663C17.3294 12.4997 17.9653 12.2363 18.4341 11.7674C18.903 11.2986 19.1663 10.6627 19.1663 9.99967V3.33301C19.1663 2.66997 18.903 2.03408 18.4341 1.56524C17.9653 1.0964 17.3294 0.833008 16.6663 0.833008ZM17.4997 9.99967C17.4997 10.2207 17.4119 10.4327 17.2556 10.5889C17.0993 10.7452 16.8874 10.833 16.6663 10.833H3.33301C3.11199 10.833 2.90003 10.7452 2.74375 10.5889C2.58747 10.4327 2.49967 10.2207 2.49967 9.99967V3.33301C2.49967 3.11199 2.58747 2.90003 2.74375 2.74375C2.90003 2.58747 3.11199 2.49967 3.33301 2.49967H16.6663C16.8874 2.49967 17.0993 2.58747 17.2556 2.74375C17.4119 2.90003 17.4997 3.11199 17.4997 3.33301V9.99967ZM9.99967 4.16634C9.50522 4.16634 9.02187 4.31296 8.61075 4.58767C8.19963 4.86237 7.87919 5.25282 7.68998 5.70963C7.50076 6.16645 7.45125 6.66911 7.54771 7.15407C7.64417 7.63902 7.88228 8.08448 8.23191 8.43411C8.58154 8.78374 9.027 9.02184 9.51195 9.11831C9.9969 9.21477 10.4996 9.16526 10.9564 8.97604C11.4132 8.78682 11.8036 8.46639 12.0783 8.05527C12.3531 7.64414 12.4997 7.16079 12.4997 6.66634C12.4997 6.0033 12.2363 5.36742 11.7674 4.89857C11.2986 4.42973 10.6627 4.16634 9.99967 4.16634ZM9.99967 7.49967C9.83486 7.49967 9.67374 7.4508 9.5367 7.35923C9.39966 7.26766 9.29285 7.13752 9.22978 6.98524C9.1667 6.83297 9.1502 6.66542 9.18235 6.50377C9.21451 6.34212 9.29388 6.19363 9.41042 6.07709C9.52696 5.96054 9.67545 5.88117 9.8371 5.84902C9.99875 5.81687 10.1663 5.83337 10.3186 5.89644C10.4708 5.95951 10.601 6.06633 10.6926 6.20337C10.7841 6.34041 10.833 6.50152 10.833 6.66634C10.833 6.88736 10.7452 7.09932 10.5889 7.2556C10.4327 7.41188 10.2207 7.49967 9.99967 7.49967ZM14.9997 5.83301C14.8349 5.83301 14.6737 5.88188 14.5367 5.97345C14.3997 6.06502 14.2928 6.19517 14.2298 6.34744C14.1667 6.49971 14.1502 6.66727 14.1824 6.82892C14.2145 6.99057 14.2939 7.13905 14.4104 7.2556C14.527 7.37214 14.6754 7.45151 14.8371 7.48366C14.9987 7.51582 15.1663 7.49931 15.3186 7.43624C15.4708 7.37317 15.601 7.26636 15.6926 7.12932C15.7841 6.99228 15.833 6.83116 15.833 6.66634C15.833 6.44533 15.7452 6.23337 15.5889 6.07709C15.4327 5.92081 15.2207 5.83301 14.9997 5.83301Z"
          fill={"#455560"}
        />
      </g>
      <defs>
        <clipPath id="clip0_9469_40538">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const reportsFinancialIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 13H12"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 17H16"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const reportsSalesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2V19C2 20.66 3.34 22 5 22H22"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 17L9.59 11.64C10.35 10.76 11.7 10.7 12.52 11.53L13.47 12.48C14.29 13.3 15.64 13.25 16.4 12.37L21 7"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const reportsPurchasesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7V21C2 21.83 2.93998 22.3 3.59998 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.28998 22.29C8.67998 22.68 9.32002 22.68 9.71002 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const reportsAccountantIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4207 5.63965H21.7007"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.29956 5.64014H9.57956"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4207 15.3301H21.7007"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4207 21.3896H21.7007"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0894 9.27V2"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.29956 22L9.57956 14.73"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.57956 22L2.29956 14.73"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const reportsInventoryIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.17004 7.43994L12 12.5499L20.77 7.46994"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 21.61V12.54"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.93001 2.48004L4.59001 5.44004C3.38001 6.11004 2.39001 7.79004 2.39001 9.17004V14.82C2.39001 16.2 3.38001 17.88 4.59001 18.55L9.93001 21.52C11.07 22.15 12.94 22.15 14.08 21.52L19.42 18.55C20.63 17.88 21.62 16.2 21.62 14.82V9.17004C21.62 7.79004 20.63 6.11004 19.42 5.44004L14.08 2.47004C12.93 1.84004 11.07 1.84004 9.93001 2.48004Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const reportsSalariesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 11.4C8 12.17 8.6 12.8 9.33 12.8H10.83C11.47 12.8 11.99 12.25 11.99 11.58C11.99 10.85 11.67 10.59 11.2 10.42L8.8 9.57995C8.32 9.40995 8 9.14995 8 8.41995C8 7.74995 8.52 7.19995 9.16 7.19995H10.66C11.4 7.20995 12 7.82995 12 8.59995"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.8501V13.5901"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6.40991V7.18991"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99 17.98C14.4028 17.98 17.98 14.4028 17.98 9.99C17.98 5.57724 14.4028 2 9.99 2C5.57724 2 2 5.57724 2 9.99C2 14.4028 5.57724 17.98 9.99 17.98Z"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.98 19.88C13.88 21.15 15.35 21.98 17.03 21.98C19.76 21.98 21.98 19.76 21.98 17.03C21.98 15.37 21.16 13.9 19.91 13"
      stroke="rgb(var(--color-brand))"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IndividualIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6663 17.5V15.8333C16.6663 14.9493 16.3152 14.1014 15.69 13.4763C15.0649 12.8512 14.217 12.5 13.333 12.5H6.66634C5.78229 12.5 4.93444 12.8512 4.30932 13.4763C3.6842 14.1014 3.33301 14.9493 3.33301 15.8333V17.5"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 9.16667C11.8413 9.16667 13.3337 7.67428 13.3337 5.83333C13.3337 3.99238 11.8413 2.5 10.0003 2.5C8.15872 2.5 6.66699 3.99238 6.66699 5.83333C6.66699 7.67428 8.15872 9.16667 10.0003 9.16667Z"
        stroke="#455560"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CompanyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.8333 2.5V6.66667H15.8333V2.5H17.5V17.5H2.5V2.5H4.16667V6.66667H9.16667V2.5H10.8333ZM4.16667 8.33333V10H5.83333V8.33333H4.16667ZM7.5 8.33333V10H9.16667V8.33333H7.5ZM10.8333 8.33333V10H12.5V8.33333H10.8333ZM14.1667 8.33333V10H15.8333V8.33333H14.1667ZM4.16667 11.6667V13.3333H5.83333V11.6667H4.16667ZM7.5 11.6667V13.3333H9.16667V11.6667H7.5ZM10.8333 11.6667V13.3333H12.5V11.6667H10.8333ZM14.1667 11.6667V13.3333H15.8333V11.6667H14.1667ZM4.16667 15V17.5H5.83333V15H4.16667ZM7.5 15V17.5H12.5V15H7.5ZM14.1667 15V17.5H15.8333V15H14.1667Z"
        fill="#455560"
      />
    </svg>
  );
};

export const reportsTaxesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 18L17 6"
      stroke="rgb(var(--color-brand))"
      stroke-width="1.5"
      strokelinecap="round"
      strokelinejoin="round"
    />
    <path
      d="M6.00002 9C7.1046 9 8 8.1046 8 7.00002C8 5.89545 7.1046 5 6.00002 5C4.89545 5 4 5.89545 4 7.00002C4 8.1046 4.89545 9 6.00002 9Z"
      stroke="rgb(var(--color-brand))"
      stroke-width="1.5"
      strokelinecap="round"
      strokelinejoin="round"
    />
    <path
      d="M18 19C19.1045 19 20 18.1045 20 17C20 15.8954 19.1045 15 18 15C16.8954 15 16 15.8954 16 17C16 18.1045 16.8954 19 18 19Z"
      stroke="rgb(var(--color-brand))"
      stroke-width="1.5"
      strokelinecap="round"
      strokelinejoin="round"
    />
  </svg>
);

export const CopyUnitIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4067 4.74861C16.9452 5.23727 17.2144 5.48161 17.3572 5.80398C17.5 6.12636 17.5 6.48996 17.5 7.21715V10.8333C17.5 12.4047 17.5 13.1903 17.0118 13.6785C16.5237 14.1667 15.738 14.1667 14.1667 14.1667H10.8333C9.262 14.1667 8.47633 14.1667 7.98816 13.6785C7.5 13.1903 7.5 12.4047 7.5 10.8333V5.83333C7.5 4.26198 7.5 3.47631 7.98816 2.98816C8.47633 2.5 9.262 2.5 10.8333 2.5H12.6417C13.2777 2.5 13.5957 2.5 13.8854 2.61185C14.1751 2.72371 14.4106 2.9374 14.8816 3.3648L16.4067 4.74861Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 5.83335H5.83333C4.26198 5.83335 3.47631 5.83335 2.98816 6.32151C2.5 6.80966 2.5 7.59534 2.5 9.16669V14.1667C2.5 15.738 2.5 16.5237 2.98816 17.0119C3.47631 17.5 4.26198 17.5 5.83333 17.5H9.16667C10.738 17.5 11.5237 17.5 12.0118 17.0119C12.5 16.5237 12.5 15.738 12.5 14.1667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const CommissionIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M5.33398 7.5998C5.33398 8.11314 5.73398 8.53314 6.22065 8.53314H7.22065C7.64732 8.53314 7.99398 8.16647 7.99398 7.7198C7.99398 7.23314 7.78065 7.0598 7.46732 6.94647L5.86732 6.38647C5.54732 6.27314 5.33398 6.0998 5.33398 5.61314C5.33398 5.16647 5.68065 4.7998 6.10732 4.7998H7.10732C7.60065 4.80647 8.00065 5.21981 8.00065 5.73314"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 8.56641V9.05974"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 4.27344V4.79344"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66065 11.9863C9.60249 11.9863 11.9873 9.60151 11.9873 6.65967C11.9873 3.71784 9.60249 1.33301 6.66065 1.33301C3.71881 1.33301 1.33398 3.71784 1.33398 6.65967C1.33398 9.60151 3.71881 11.9863 6.66065 11.9863Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.6543 13.2537C9.2543 14.1003 10.2343 14.6537 11.3543 14.6537C13.1743 14.6537 14.6543 13.1737 14.6543 11.3537C14.6543 10.247 14.1076 9.26699 13.2743 8.66699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WaterIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    {...props}
  >
    <g clip-path="url(#clip0_4275_34207)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.6663C10.7614 14.6663 13 12.4278 13 9.66634C13 4.99967 8 1.33301 8 1.33301C8 1.33301 3 4.99967 3 9.66634C3 12.4278 5.23857 14.6663 8 14.6663Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4275_34207">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ElectricityIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    {...props}
  >
    <g clip-path="url(#clip0_4275_34210)">
      <path
        d="M10.334 1.33301H5.33398L3.33398 8.99967H6.00065L4.66732 14.6663L13.334 5.33301H9.33398L10.334 1.33301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4275_34210">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GarbageIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    {...props}
  >
    <g clip-path="url(#clip0_4276_34991)">
      <path
        d="M2.40039 4.15961H3.64484M3.64484 4.15961H13.6004M3.64484 4.15961V13.1196C3.64484 13.4591 3.77595 13.7847 4.00932 14.0247C4.2427 14.2648 4.55923 14.3996 4.88928 14.3996H11.1115C11.4415 14.3996 11.7581 14.2648 11.9915 14.0247C12.2248 13.7847 12.3559 13.4591 12.3559 13.1196V4.15961M5.5115 4.15961V2.87961C5.5115 2.54013 5.64261 2.21456 5.87599 1.97451C6.10937 1.73447 6.4259 1.59961 6.75595 1.59961H9.24484C9.57488 1.59961 9.89141 1.73447 10.1248 1.97451C10.3582 2.21456 10.4893 2.54013 10.4893 2.87961V4.15961M6.75595 7.35961V11.1996M9.24484 7.35961V11.1996"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4276_34991">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MaintenanceIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M5.59039 1.97757C6.20082 1.36492 6.98893 0.956804 7.84456 0.810262C8.70018 0.663701 9.58057 0.78604 10.3627 1.16017L8.30927 3.21352C8.11248 3.41087 8.00211 3.67726 8.00211 3.95487C8.00211 4.23248 8.11248 4.49889 8.30927 4.69622L8.80401 5.19108C8.901 5.28837 9.01645 5.36562 9.14373 5.41832C9.27097 5.47105 9.40752 5.49817 9.54544 5.49817C9.68335 5.49817 9.8199 5.47105 9.94714 5.41832C10.0744 5.36562 10.1899 5.28837 10.2869 5.19108L12.3403 3.13773C12.7577 4.01105 12.8599 5.00013 12.6298 5.93929C12.3997 6.87845 11.8513 7.71061 11.0764 8.29635C10.4648 8.75574 9.73754 9.03904 8.97435 9.11522C8.21116 9.1914 7.44156 9.05749 6.75003 8.72819L3.03471 12.4429C2.93775 12.5402 2.82232 12.6174 2.69507 12.6702C2.56782 12.7229 2.4313 12.75 2.29341 12.75C2.15553 12.75 2.01901 12.7229 1.89176 12.6702C1.76451 12.6174 1.64908 12.5402 1.55212 12.4429L1.05739 11.9481C0.860457 11.7508 0.75 11.4844 0.75 11.2067C0.75 10.9291 0.860457 10.6626 1.05739 10.4654L4.77324 6.74959C4.39892 5.96721 4.27655 5.08945 4.42275 4.23561C4.56897 3.38181 4.97666 2.59339 5.59039 1.97757Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ParkingIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="7"
    viewBox="0 0 6 7"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M0.75 4.08333H3.08333C3.52536 4.08333 3.94928 3.90774 4.26184 3.59518C4.57441 3.28262 4.75 2.85869 4.75 2.41667C4.75 1.97464 4.57441 1.55072 4.26184 1.23816C3.94928 0.925595 3.52536 0.75 3.08333 0.75H0.75V6.08333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InsuranceIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M12.63 6.82499C12.63 10.085 10.2634 13.1383 7.03002 14.0317C6.81002 14.0917 6.57002 14.0917 6.35002 14.0317C3.11666 13.1383 0.75 10.085 0.75 6.82499V3.89831C0.75 3.35164 1.16334 2.73165 1.67667 2.52498L5.39002 1.005C6.22335 0.665 7.16335 0.665 7.99669 1.005L11.71 2.52498C12.2167 2.73165 12.6367 3.35164 12.6367 3.89831L12.63 6.82499Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const hoaFeeIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.84807 0.280925C6.08213 0.0988525 6.3702 0 6.66674 0C6.96327 0 7.25135 0.0988525 7.4854 0.280925L13.0747 4.62759C13.5767 5.01893 13.2994 5.82226 12.6647 5.82226H12.0001V11.1556C12.0001 11.5092 11.8596 11.8484 11.6095 12.0984C11.3595 12.3485 11.0204 12.4889 10.6667 12.4889H2.66674C2.31311 12.4889 1.97398 12.3485 1.72393 12.0984C1.47388 11.8484 1.3334 11.5092 1.3334 11.1556V5.82226H0.668736C0.0334025 5.82226 -0.242597 5.01826 0.258736 4.62826L5.84807 0.280925ZM2.41674 4.63893C2.5694 4.76226 2.66674 4.95093 2.66674 5.16226V11.1556H10.6667V5.16226C10.6667 4.95093 10.7641 4.76226 10.9167 4.63893L6.66674 1.33359L2.41674 4.63893Z"
      fill="currentColor"
    />
  </svg>
);

export const FileLineIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    {...props}
  >
    <g clipPath="url(#clip0_2422_22520)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H18C18.5304 2 19.0391 2.21071 19.4142 2.58579C19.7893 2.96086 20 3.46957 20 4V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4ZM18 4H6V20H18V4ZM8 9C8 8.73478 8.10536 8.48043 8.29289 8.29289C8.48043 8.10536 8.73478 8 9 8H15C15.2652 8 15.5196 8.10536 15.7071 8.29289C15.8946 8.48043 16 8.73478 16 9C16 9.26522 15.8946 9.51957 15.7071 9.70711C15.5196 9.89464 15.2652 10 15 10H9C8.73478 10 8.48043 9.89464 8.29289 9.70711C8.10536 9.51957 8 9.26522 8 9ZM9 13C8.73478 13 8.48043 13.1054 8.29289 13.2929C8.10536 13.4804 8 13.7348 8 14C8 14.2652 8.10536 14.5196 8.29289 14.7071C8.48043 14.8946 8.73478 15 9 15H12C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13H9Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2422_22520">
        <path d="M0 12C0 5.37258 5.37258 0 12 0H24V24H0V12Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MultipleCoinsIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M19.3 7.91949V13.0695C19.3 16.1495 17.54 17.4695 14.9 17.4695H6.10995C5.65995 17.4695 5.22996 17.4295 4.82996 17.3395C4.57996 17.2995 4.33996 17.2295 4.11996 17.1495C2.61996 16.5895 1.70996 15.2895 1.70996 13.0695V7.91949C1.70996 4.83949 3.46995 3.51953 6.10995 3.51953H14.9C17.14 3.51953 18.75 4.46953 19.18 6.63953C19.25 7.03953 19.3 7.44949 19.3 7.91949Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.3011 10.9196V16.0696C22.3011 19.1496 20.5411 20.4696 17.9011 20.4696H9.11105C8.37105 20.4696 7.70106 20.3697 7.12106 20.1497C5.93106 19.7097 5.12105 18.7997 4.83105 17.3397C5.23105 17.4297 5.66105 17.4696 6.11105 17.4696H14.9011C17.5411 17.4696 19.3011 16.1496 19.3011 13.0696V7.91962C19.3011 7.44962 19.2611 7.02965 19.1811 6.63965C21.0811 7.03965 22.3011 8.37962 22.3011 10.9196Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4984 13.1394C11.9564 13.1394 13.1384 11.9574 13.1384 10.4994C13.1384 9.04136 11.9564 7.85938 10.4984 7.85938C9.04038 7.85938 7.8584 9.04136 7.8584 10.4994C7.8584 11.9574 9.04038 13.1394 10.4984 13.1394Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.77991 8.2998V12.6998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2217 8.2998V12.6998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
// NOTE: AbsherLogo cannot be CSS-themed (e.g. color, fill, stroke) because it uses
// a raster image (PNG-embedded SVG) for the Absher brand mark.
export const AbsherLogo = ({ className = "size-4", ...props }) => (
  <img src={"/icons/absher.svg"} alt="Absher Logo" className={className} {...props} />
);
export const PencilIcon = ({ className = "size-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M11 4H4C3.47 4 2.96 4.21 2.59 4.59C2.21 4.96 2 5.47 2 6V20C2 20.53 2.21 21.04 2.59 21.41C2.96 21.79 3.47 22 4 22H18C18.53 22 19.04 21.79 19.41 21.41C19.79 21.04 20 20.53 20 20V13"
      stroke="rgb(var(--color-info-icon))"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 2.5C18.9 2.1 19.44 1.88 20 1.88C20.56 1.88 21.1 2.1 21.5 2.5C21.9 2.9 22.12 3.44 22.12 4C22.12 4.56 21.9 5.1 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z"
      stroke="rgb(var(--color-info-icon))"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CheckMark = () => (
  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" aria-hidden="true">
    <path
      d="M1 4L3.5 6.5L9 1"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PaperPlane = ({ className, ...props }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 19l9-7-9-7v7H3v2h9v7z"
    />
  </svg>
);
export const CloseIcon = ({ className, ...props }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);
export const Riyal = ({ className = "", style = {} }) => (
  <span
    aria-hidden="true"
    className={`inline-block align-middle ${className}`.trim()}
    style={{
      width: "0.72em",
      height: "0.82em",
      background: "currentColor",
      WebkitMask: "url('/icons/sar-symbol.svg') center / contain no-repeat",
      mask: "url('/icons/sar-symbol.svg') center / contain no-repeat",
      verticalAlign: "middle",
      ...style,
    }}
  />
);
